(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"]) return;
  try {
    
(function () {
  if (window.__agInit) return; window.__agInit = true;

  var root = document.querySelector('[data-ag]');
  if (!root) return;

  var minAge = parseInt(root.dataset.minAge, 10) || 18;
  var persistenceDays = parseInt(root.dataset.persistenceDays, 10) || 30;
  var declineUrl = root.dataset.declineUrl || '/';
  var designMode = root.dataset.designMode === 'true';
  var STORAGE_KEY = 'nf_age_ok_until';

  function isVerified() {
    try {
      var until = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      return until && Date.now() < until;
    } catch (e) { return false; }
  }

  function show() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ag-locked');
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.lock('age-gate');
    requestAnimationFrame(function () { root.classList.add('ag--active'); });
    /* Move focus to the confirm button for keyboard / screen reader users */
    var confirmBtn = root.querySelector('[data-ag-confirm]');
    if (confirmBtn) setTimeout(function () { confirmBtn.focus(); }, 50);
  }

  function hide() {
    root.classList.remove('ag--active');
    document.body.classList.remove('ag-locked');
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.unlock('age-gate');
    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
    }, 320);
  }

  function confirm() {
    try {
      var until = Date.now() + persistenceDays * 86400000;
      localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {}
    hide();
  }

  function decline() {
    /* Don't persist a "verified false" — they'll see it again on next visit */
    window.location.href = declineUrl;
  }

  /* Wire buttons */
  var confirmBtn = root.querySelector('[data-ag-confirm]');
  var declineBtn = root.querySelector('[data-ag-decline]');
  if (confirmBtn) confirmBtn.addEventListener('click', confirm);
  if (declineBtn) declineBtn.addEventListener('click', decline);

  /* Trap focus inside the dialog while it's open (accessibility) */
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      /* Esc behaves like decline (do not let the user dismiss without confirming) */
      decline();
    }
  });

  /* ── Theme editor: only show when this section is selected ── */
  if (designMode) {
    var section = root.closest('.shopify-section');
    if (!section) return;
    function showEditor() { show(); }
    function hideEditor() { hide(); }
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId && section.id.indexOf(e.detail.sectionId) !== -1) showEditor();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId && section.id.indexOf(e.detail.sectionId) !== -1) hideEditor();
    });
    return;
  }

  /* ── Storefront: render gate if not yet verified ── */
  if (isVerified()) return;
  show();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundler-blocks"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (customElements.get('bundle-builder')) return;

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.items = {};          // { variantId: { price, qty, title } }
      this.tiers = [];
      this.activeDiscount = 0;

      /* Summary elements */
      this.summaryEl       = this.querySelector('[data-summary]');
      this.summaryItems    = this.querySelector('[data-summary-items]');
      this.summaryOriginal = this.querySelector('[data-summary-original]');
      this.summaryTotal    = this.querySelector('[data-summary-total]');
      this.summarySavings  = this.querySelector('[data-summary-savings]');
      this.summaryCount    = this.querySelector('[data-summary-count]');
      this.summaryAdd      = this.querySelector('[data-summary-add]');
      this.discountRow     = this.querySelector('[data-summary-discount-row]');
      this.progressFill    = this.querySelector('[data-progress-fill]');
      this.progressText    = this.querySelector('[data-progress-text]');

      this.parseTiers();
      this.localizeTierLabels();
      this.bindTierClicks();
      this.bindProductActions();
      this.bindVariantSelects();
      this.bindModeSwitcher();
      this.bindKitFilters();
      this.bindKitAddToCart();
      this.bindPsuHelper();
      this.bindSummaryAdd();
    }

    /* ── Tiers (spend-based, thresholds defined in USD) ── */
    parseTiers() {
      var tierBtns = this.querySelectorAll('[data-tier]');
      var self = this;
      /* Thresholds are USD base amounts; convert to the shopper's
         presentment currency via Shopify.currency.rate (falls back to 1). */
      var rate = 1;
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
        rate = parseFloat(window.Shopify.currency.rate) || 1;
      }
      this.currencyRate = rate;
      tierBtns.forEach(function(btn) {
        var minUsd = parseFloat(btn.dataset.minSpend) || 0;
        var minLocal = parseFloat(btn.dataset.minLocal);
        self.tiers.push({
          el: btn,
          minUsd: minUsd,
          minCents: isNaN(minLocal) ? Math.round(minUsd * rate * 100) : Math.round(minLocal * 100),
          discount: parseInt(btn.dataset.discount, 10)
        });
      });
      this.tiers.sort(function(a, b) { return a.minCents - b.minCents; });
      if (this.tiers.length > 0) {
        this.activeDiscount = this.tiers[0].discount;
      }
    }

    bindTierClicks() {
      var self = this;
      this.tiers.forEach(function(tier) {
        tier.el.addEventListener('click', function() {
          self.tiers.forEach(function(t) { t.el.classList.remove('is-active'); });
          tier.el.classList.add('is-active');
          self.activeDiscount = tier.discount;
          self.updateSummary();
        });
      });
    }

    /* ── Mode switcher ── */
    bindModeSwitcher() {
      var modeCards = this.querySelectorAll('[data-mode]');
      var modeContents = this.querySelectorAll('[data-mode-content]');
      var self = this;

      modeCards.forEach(function(card) {
        card.addEventListener('click', function() {
          var mode = this.dataset.mode;
          modeCards.forEach(function(c) { c.classList.remove('is-active'); });
          this.classList.add('is-active');
          modeContents.forEach(function(mc) {
            mc.hidden = mc.dataset.modeContent !== mode;
          });
          // Update hero tier pills visibility
          var tierPills = self.querySelector('.bb__hero-tiers');
          if (tierPills) tierPills.style.display = mode === 'kits' ? 'none' : '';
        });
      });
    }

    /* ── Kit filter pills ── */
    bindKitFilters() {
      var kitGrid = this.querySelector('[data-kit-grid]');
      if (!kitGrid) return;
      var filterContainer = this.querySelector('[data-kit-filters]');
      var kitItems = kitGrid.querySelectorAll('[data-kit-item]');
      // Build filter pills from product tags
      var tagSet = {};
      kitItems.forEach(function(item) {
        var tags = (item.dataset.kitTags || '').split(',').filter(Boolean);
        tags.forEach(function(t) {
          var clean = t.trim();
          if (clean && clean !== 'blocks') tagSet[clean] = true;
        });
      });
      Object.keys(tagSet).sort().forEach(function(tag) {
        var pill = document.createElement('button');
        pill.type = 'button';
        pill.className = 'bb__filter-pill';
        pill.dataset.filter = tag;
        pill.textContent = tag.charAt(0).toUpperCase() + tag.slice(1).replace(/-/g, ' ');
        filterContainer.appendChild(pill);
      });
      // Filter click handler
      filterContainer.addEventListener('click', function(e) {
        var pill = e.target.closest('[data-filter]');
        if (!pill) return;
        filterContainer.querySelectorAll('.bb__filter-pill').forEach(function(p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        var filter = pill.dataset.filter;
        kitItems.forEach(function(item) {
          if (filter === 'all') { item.hidden = false; return; }
          var tags = (item.dataset.kitTags || '').split(',');
          item.hidden = tags.indexOf(filter) === -1;
        });
      });
    }

    /* ── Inline PSU helper ── */
    bindPsuHelper() {
      var input = this.querySelector('[data-psu-panels]');
      var countEl = this.querySelector('[data-psu-count]');
      if (!input || !countEl) return;
      var count75El = this.querySelector('[data-psu-count-75]');
      var watts_per_panel = 3.0;
      var psu_capacity = 44;    // 42W PSU effective watts
      var psu_capacity_75 = 78; // 75W PSU effective watts (Marta, 2026-08-10)
      function calc() {
        var panels = parseInt(input.value, 10) || 0;
        if (panels < 1) panels = 1;
        var total = panels * watts_per_panel;
        countEl.textContent = Math.max(1, Math.ceil(total / psu_capacity));
        if (count75El) count75El.textContent = Math.max(1, Math.ceil(total / psu_capacity_75));
      }
      input.addEventListener('input', calc);
      calc();
    }

    /* ── Kit add to cart ── */
    bindKitAddToCart() {
      this.querySelectorAll('[data-kit-add]').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var vid = this.dataset.variantId;
          if (!vid || this.classList.contains('is-adding')) return;
          this.classList.add('is-adding');
          var origText = this.textContent;
          this.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:nfSpin 0.7s linear infinite;vertical-align:-2px"><path d="M12 2a10 10 0 1 0 10 10"/></svg>';
          var btnRef = this;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            btnRef.classList.remove('is-adding');
            btnRef.classList.add('is-added');
            btnRef.textContent = 'Added \u2713';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(function() {
              btnRef.classList.remove('is-added');
              btnRef.textContent = origText;
            }, 1200);
          })
          .catch(function() {
            btnRef.classList.remove('is-adding');
            btnRef.textContent = origText;
          });
        });
      });
    }

    /* ── Variant selects ── */
    bindVariantSelects() {
      var self = this;
      var selects = this.querySelectorAll('[data-variant-select]');
      selects.forEach(function(sel) {
        sel.addEventListener('change', function() {
          var card = sel.closest('[data-product-item]');
          if (!card) return;
          var oldVid = card.dataset.variantId;
          var newVid = sel.value;
          var newPrice = parseInt(sel.selectedOptions[0].dataset.price, 10);

          card.dataset.variantId = newVid;
          card.dataset.price = newPrice;

          // Update price display
          var priceEl = card.querySelector('.bb__card-price');
          if (priceEl) priceEl.textContent = self.formatMoney(newPrice);

          // Migrate item if it was in bundle
          if (self.items[oldVid]) {
            var existing = self.items[oldVid];
            delete self.items[oldVid];
            self.items[newVid] = { price: newPrice, qty: existing.qty, title: existing.title };
            self.updateSummary();
          }
        });
      });
    }

    /* ── Product actions ── */
    bindProductActions() {
      var productItems = this.querySelectorAll('[data-product-item]');
      var self = this;

      productItems.forEach(function(item) {
        var addBtn = item.querySelector('[data-product-add]');
        var qtyWrap = item.querySelector('[data-product-qty]');
        var qtyVal = item.querySelector('[data-qty-value]');
        var minusBtn = item.querySelector('[data-qty-minus]');
        var plusBtn = item.querySelector('[data-qty-plus]');

        /* Show stepper at 0 by default, hide Add button */
        if (qtyWrap) { qtyWrap.hidden = false; }
        if (qtyVal) { qtyVal.textContent = '0'; }
        if (addBtn) { addBtn.hidden = true; }

        function addOrIncrement() {
          var vid = item.dataset.variantId;
          var price = parseInt(item.dataset.price, 10);
          var titleEl = item.querySelector('.bb__card-title');
          var title = titleEl ? titleEl.textContent.trim() : 'Item';

          if (!self.items[vid]) {
            self.items[vid] = { price: price, qty: 1, title: title };
            item.classList.add('is-selected');
          } else if (self.items[vid].qty < 20) {
            self.items[vid].qty++;
          }
          if (qtyVal) qtyVal.textContent = self.items[vid].qty;
          self.updateSummary();
        }

        if (addBtn) {
          addBtn.addEventListener('click', addOrIncrement);
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', addOrIncrement);
        }

        if (minusBtn) {
          minusBtn.addEventListener('click', function() {
            var vid = item.dataset.variantId;
            if (!self.items[vid]) return;
            if (self.items[vid].qty <= 1) {
              delete self.items[vid];
              if (qtyVal) qtyVal.textContent = '0';
              item.classList.remove('is-selected');
            } else {
              self.items[vid].qty--;
              if (qtyVal) qtyVal.textContent = self.items[vid].qty;
            }
            self.updateSummary();
          });
        }
      });
    }

    /* ── Calculations ── */
    getTotalItems() {
      var total = 0;
      for (var vid in this.items) {
        total += this.items[vid].qty;
      }
      return total;
    }

    getOriginalTotal() {
      var total = 0;
      for (var vid in this.items) {
        total += this.items[vid].price * this.items[vid].qty;
      }
      return total;
    }

    getActiveTierDiscount() {
      /* getOriginalTotal() returns presentment-currency cents
         (variant.price rendered raw in Liquid = cents). */
      var subtotal = this.getOriginalTotal();
      var discount = 0;
      for (var i = 0; i < this.tiers.length; i++) {
        if (subtotal > 0 && subtotal >= this.tiers[i].minCents) {
          discount = this.tiers[i].discount;
        }
      }
      return discount;
    }

    /* MEL-1196: Shopify does not take the percentage off the order total. It
       allocates the automatic discount per UNIT, truncates that unit's share
       to the cent, then multiplies by the quantity. Rounding once on the
       subtotal drifts against the real cart: a $59.99 + $24.99 bundle showed
       $67.98 here while checkout charged $68.00, because Shopify keeps
       11.99 + 4.99 rather than 20% of 84.98. Mirror its arithmetic exactly so
       the summary and the cart can never disagree. */
    getTierSavings(discount) {
      if (!discount) return 0;
      var savings = 0;
      for (var vid in this.items) {
        var it = this.items[vid];
        savings += Math.floor(it.price * discount / 100) * it.qty;
      }
      return savings;
    }

    /* Tier thresholds are authored in USD, but the storefront runs in seven
       market currencies and Shopify converts the discount minimum with the
       same rate we use for gating. The label has to follow, otherwise an EU
       shopper is told "$75+" for a threshold that is really EUR 64.54. On USD
       the rate is 1 and the merchandiser's copy is left untouched. */
    localizeTierLabels() {
      if (!this.currencyRate || this.currencyRate === 1) return;
      var self = this;
      this.querySelectorAll('[data-tier-money]').forEach(function(el) {
        var usd = parseFloat(el.dataset.tierMoney) || 0;
        if (!usd) return;
        el.textContent = self.formatMoney(Math.round(usd * self.currencyRate * 100));
      });
    }

    formatMoney(cents) {
      return window.NanoleafTheme.formatMoney(cents);
    }

    /* ── Tier state ── */
    updateTierStates() {
      var subtotal = this.getOriginalTotal();
      this.tiers.forEach(function(tier) {
        if (subtotal > 0 && subtotal >= tier.minCents) {
          tier.el.classList.add('is-reached');
        } else {
          tier.el.classList.remove('is-reached');
        }
      });

      var highestReached = null;
      for (var i = this.tiers.length - 1; i >= 0; i--) {
        if (subtotal > 0 && subtotal >= this.tiers[i].minCents) {
          highestReached = this.tiers[i];
          break;
        }
      }
      if (highestReached) {
        this.tiers.forEach(function(t) { t.el.classList.remove('is-active'); });
        highestReached.el.classList.add('is-active');
        this.activeDiscount = highestReached.discount;
      }
    }

    /* ── Progress bar (spend-based) ── */
    updateProgress() {
      var count = this.getTotalItems();
      var subtotal = this.getOriginalTotal();
      if (!this.progressFill || !this.progressText) return;

      if (count === 0) {
        this.progressFill.style.width = '0%';
        this.progressText.textContent = 'Add items to start building';
        return;
      }

      // Find next spend tier to reach
      var nextTier = null;
      for (var i = 0; i < this.tiers.length; i++) {
        if (subtotal < this.tiers[i].minCents) {
          nextTier = this.tiers[i];
          break;
        }
      }

      if (!nextTier) {
        // Top tier reached
        this.progressFill.style.width = '100%';
        var topPct = this.tiers.length > 0 ? this.tiers[this.tiers.length - 1].discount : 0;
        this.progressText.textContent = "You've reached the maximum " + topPct + '% discount!';
        return;
      }

      var prevMin = 0;
      for (var j = 0; j < this.tiers.length; j++) {
        if (this.tiers[j] === nextTier) break;
        prevMin = this.tiers[j].minCents;
      }
      var progress = ((subtotal - prevMin) / (nextTier.minCents - prevMin)) * 100;
      progress = Math.min(Math.max(progress, 5), 100);
      this.progressFill.style.width = progress + '%';

      var remaining = nextTier.minCents - subtotal;
      this.progressText.textContent = 'Add ' + this.formatMoney(remaining) + ' more to get ' + nextTier.discount + '% OFF';
    }

    /* ── Summary ── */
    updateSummary() {
      var count = this.getTotalItems();
      var original = this.getOriginalTotal();

      this.updateTierStates();
      this.updateProgress();

      var discount = this.getActiveTierDiscount();
      var savings = this.getTierSavings(discount);
      var discounted = original - savings;

      // Summary items list
      if (this.summaryItems) {
        var html = '';
        for (var vid in this.items) {
          var it = this.items[vid];
          html += '<div class="bb__summary-item">';
          html += '<span class="bb__summary-item-name">' + it.title + (it.qty > 1 ? ' x' + it.qty : '') + '</span>';
          html += '<span>' + this.formatMoney(it.price * it.qty) + '</span>';
          html += '</div>';
        }
        this.summaryItems.innerHTML = html;
      }

      if (this.summaryOriginal) {
        this.summaryOriginal.textContent = this.formatMoney(original);
      }
      if (this.summaryTotal) {
        this.summaryTotal.textContent = this.formatMoney(discounted);
      }
      if (this.discountRow) {
        if (discount > 0) {
          this.discountRow.hidden = false;
          if (this.summarySavings) {
            this.summarySavings.textContent = '-' + this.formatMoney(savings) + ' (' + discount + '% off)';
          }
        } else {
          this.discountRow.hidden = true;
        }
      }
      if (this.summaryCount) {
        this.summaryCount.textContent = count + (count === 1 ? ' item' : ' items') + ' in bundle';
      }
      if (this.summaryAdd) {
        this.summaryAdd.disabled = count === 0;
      }
    }

    /* ── Cart add ── */
    bindSummaryAdd() {
      var self = this;
      if (!this.summaryAdd) return;

      this.summaryAdd.addEventListener('click', function() {
        var keys = Object.keys(self.items);
        if (keys.length === 0 || self.summaryAdd.classList.contains('is-adding')) return;

        self.summaryAdd.classList.add('is-adding');
        self.summaryAdd.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:nfSpin 0.7s linear infinite;vertical-align:-3px"><path d="M12 2a10 10 0 1 0 10 10"/></svg>';

        var bundleId = Date.now().toString();
        var discount = self.getActiveTierDiscount();

        var cartItems = keys.map(function(vid) {
          return {
            id: parseInt(vid, 10),
            quantity: self.items[vid].qty,
            properties: {
              _bundle_id: bundleId,
              _bundle_discount: discount + '%'
            }
          };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          /* Prime the checkout-level discount for the earned tier.
             Codes exist store-side: BLOCKS20/25/30/35 (min spend enforced
             by the codes themselves in USD). No tier reached \u2192 no call. */
          var codeMap = { 20: 'BLOCKS20', 25: 'BLOCKS25', 30: 'BLOCKS30', 35: 'BLOCKS35' };
          var code = codeMap[discount];
          if (code) {
            return fetch('/discount/' + code).catch(function() {});
          }
        })
        .then(function() {
          self.summaryAdd.classList.remove('is-adding');
          self.summaryAdd.classList.add('is-added');
          self.summaryAdd.textContent = 'Added \u2713';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            self.summaryAdd.classList.remove('is-added');
            self.summaryAdd.textContent = 'Add Bundle to Cart';
          }, 1200);
        })
        .catch(function() {
          self.summaryAdd.classList.remove('is-adding');
          self.summaryAdd.textContent = 'Add Bundle to Cart';
        });
      });
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundler"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (customElements.get('bundle-builder')) return;

  class BundleBuilder extends HTMLElement {
    connectedCallback() {
      this.items = {};          // { variantId: { price, qty } }
      this.tiers = [];
      this.activeDiscount = 0;

      this.summaryEl      = this.querySelector('[data-summary]');
      this.summaryCount   = this.querySelector('[data-summary-count]');
      this.summaryOriginal= this.querySelector('[data-summary-original]');
      this.summaryTotal   = this.querySelector('[data-summary-total]');
      this.summarySavings = this.querySelector('[data-summary-savings]');
      this.summaryAdd     = this.querySelector('[data-summary-add]');

      this.parseTiers();
      this.bindTierClicks();
      this.bindProductActions();
      this.bindSummaryAdd();
    }

    parseTiers() {
      var tierBtns = this.querySelectorAll('[data-tier]');
      var self = this;
      tierBtns.forEach(function(btn) {
        self.tiers.push({
          el: btn,
          min: parseInt(btn.dataset.min, 10),
          minType: btn.dataset.minType || 'items',
          discount: parseInt(btn.dataset.discount, 10),
          discountType: btn.dataset.discountType || 'percent'
        });
      });
      // Sort ascending by min
      this.tiers.sort(function(a, b) { return a.min - b.min; });
      if (this.tiers.length > 0) {
        this.activeDiscount = this.tiers[0].discount;
      }
    }

    bindTierClicks() {
      var self = this;
      this.tiers.forEach(function(tier) {
        tier.el.addEventListener('click', function() {
          self.tiers.forEach(function(t) { t.el.classList.remove('is-active'); });
          tier.el.classList.add('is-active');
          self.activeDiscount = tier.discount;
          self.updateSummary();
        });
      });
    }

    bindProductActions() {
      var productItems = this.querySelectorAll('[data-product-item]');
      var self = this;

      productItems.forEach(function(item) {
        var vid = item.dataset.variantId;
        var price = parseInt(item.dataset.price, 10);
        var addBtn = item.querySelector('[data-product-add]');
        var qtyWrap = item.querySelector('[data-product-qty]');
        var qtyVal = item.querySelector('[data-qty-value]');
        var minusBtn = item.querySelector('[data-qty-minus]');
        var plusBtn = item.querySelector('[data-qty-plus]');

        if (!addBtn) return;

        addBtn.addEventListener('click', function() {
          self.items[vid] = { price: price, qty: 1 };
          addBtn.hidden = true;
          if (qtyWrap) qtyWrap.hidden = false;
          if (qtyVal) qtyVal.textContent = '1';
          item.classList.add('is-selected');
          self.updateSummary();
        });

        if (minusBtn) {
          minusBtn.addEventListener('click', function() {
            if (!self.items[vid]) return;
            if (self.items[vid].qty <= 1) {
              delete self.items[vid];
              addBtn.hidden = false;
              if (qtyWrap) qtyWrap.hidden = true;
              item.classList.remove('is-selected');
            } else {
              self.items[vid].qty--;
              if (qtyVal) qtyVal.textContent = self.items[vid].qty;
            }
            self.updateSummary();
          });
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function() {
            if (!self.items[vid]) return;
            if (self.items[vid].qty < 20) {
              self.items[vid].qty++;
              if (qtyVal) qtyVal.textContent = self.items[vid].qty;
              self.updateSummary();
            }
          });
        }
      });
    }

    getTotalItems() {
      var total = 0;
      for (var vid in this.items) {
        total += this.items[vid].qty;
      }
      return total;
    }

    getOriginalTotal() {
      var total = 0;
      for (var vid in this.items) {
        total += this.items[vid].price * this.items[vid].qty;
      }
      return total;
    }

    /* A tier qualifies on item count or on subtotal, depending on how it
       was authored. Everything monetary stays in cents. */
    tierReached(tier) {
      var measure = tier.minType === 'subtotal' ? this.getOriginalTotal() : this.getTotalItems();
      return measure >= tier.min;
    }

    /* Best reached tier by actual savings, not by position: with a mix of
       percentage and flat-amount tiers the highest threshold is not always
       the better deal, and the customer should get the better one. */
    getActiveTier() {
      var active = null, best = -1, self = this;
      this.tiers.forEach(function(tier) {
        if (!self.tierReached(tier)) return;
        var s = self.getSavings(tier);
        if (s > best) { best = s; active = tier; }
      });
      return active;
    }

    /* Savings in cents, whichever way the tier expresses its reward.
       A flat amount never exceeds the bundle total. */
    getSavings(tier) {
      if (!tier) return 0;
      var original = this.getOriginalTotal();
      if (tier.discountType === 'amount') {
        return Math.min(tier.discount, original);
      }
      return Math.round(original * tier.discount / 100);
    }

    getDiscountLabel(tier) {
      if (!tier) return '';
      if (tier.discountType === 'amount') return this.formatMoney(tier.discount) + ' off';
      return tier.discount + '% off';
    }

    getActiveTierDiscount() {
      var tier = this.getActiveTier();
      return tier ? tier.discount : 0;
    }

    updateTierStates() {
      var self = this;
      this.tiers.forEach(function(tier) {
        if (self.tierReached(tier)) {
          tier.el.classList.add('is-reached');
        } else {
          tier.el.classList.remove('is-reached');
        }
      });

      // Auto-select highest reached tier
      var highestReached = null;
      for (var i = this.tiers.length - 1; i >= 0; i--) {
        if (this.tierReached(this.tiers[i])) {
          highestReached = this.tiers[i];
          break;
        }
      }
      if (highestReached) {
        this.tiers.forEach(function(t) { t.el.classList.remove('is-active'); });
        highestReached.el.classList.add('is-active');
        this.activeDiscount = highestReached.discount;
      }
    }

    formatMoney(cents) {
      return window.NanoleafTheme.formatMoney(cents);
    }

    updateSummary() {
      var count = this.getTotalItems();
      var original = this.getOriginalTotal();

      this.updateTierStates();
      var discount = this.getActiveTierDiscount();

      if (count === 0) {
        if (this.summaryEl) {
          this.summaryEl.classList.remove('is-visible');
          setTimeout(function() { this.summaryEl.hidden = true; }.bind(this), 400);
        }
        return;
      }

      if (this.summaryEl) {
        this.summaryEl.hidden = false;
        // Force reflow for transition
        void this.summaryEl.offsetWidth;
        this.summaryEl.classList.add('is-visible');
      }

      var tier = this.getActiveTier();
      var savings = this.getSavings(tier);
      var discounted = original - savings;

      if (this.summaryCount) {
        this.summaryCount.textContent = count + (count === 1 ? ' item' : ' items');
      }
      if (this.summaryOriginal && savings > 0) {
        this.summaryOriginal.textContent = this.formatMoney(original);
        this.summaryOriginal.hidden = false;
      } else if (this.summaryOriginal) {
        this.summaryOriginal.hidden = true;
      }
      if (this.summaryTotal) {
        this.summaryTotal.textContent = this.formatMoney(discounted);
      }
      if (this.summarySavings && savings > 0) {
        this.summarySavings.textContent = 'You save ' + this.formatMoney(savings) + ' (' + this.getDiscountLabel(tier) + ')';
        this.summarySavings.hidden = false;
      } else if (this.summarySavings) {
        this.summarySavings.hidden = true;
      }
      if (this.summaryAdd) {
        this.summaryAdd.disabled = false;
      }
    }

    bindSummaryAdd() {
      var self = this;
      if (!this.summaryAdd) return;

      this.summaryAdd.addEventListener('click', function() {
        var keys = Object.keys(self.items);
        if (keys.length === 0 || self.summaryAdd.classList.contains('is-adding')) return;

        self.summaryAdd.classList.add('is-adding');
        self.summaryAdd.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:nfSpin 0.7s linear infinite;vertical-align:-3px"><path d="M12 2a10 10 0 1 0 10 10"/></svg>';

        var bundleId = Date.now().toString();
        var tier = self.getActiveTier();
        /* Carries the tier through to the order so the discount that runs in
           Shopify can be reconciled against what the page promised. */
        var discountLabel = self.getDiscountLabel(tier) || 'none';

        var cartItems = keys.map(function(vid) {
          return {
            id: parseInt(vid, 10),
            quantity: self.items[vid].qty,
            properties: {
              _bundle_id: bundleId,
              _bundle_discount: discountLabel
            }
          };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          self.summaryAdd.classList.remove('is-adding');
          self.summaryAdd.classList.add('is-added');
          self.summaryAdd.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function() {
            self.summaryAdd.classList.remove('is-added');
            self.summaryAdd.textContent = 'Add Bundle to Cart';
          }, 1200);
        })
        .catch(function() {
          self.summaryAdd.classList.remove('is-adding');
          self.summaryAdd.textContent = 'Add Bundle to Cart';
        });
      });
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-benefits"] && !Shopify.designMode) return;
  try {
    
(function() {
  var track = document.querySelector('[data-benefits-track]');
  var prevBtn = document.querySelector('[data-benefits-prev]');
  var nextBtn = document.querySelector('[data-benefits-next]');
  var dotsWrap = document.querySelector('[data-benefits-dots]');
  if (!track || !prevBtn || !nextBtn) return;

  var cards = track.children;
  var cardWidth = 300 + 20;

  /* Build dots */
  if (dotsWrap && cards.length > 0) {
    for (var i = 0; i < cards.length; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'cl-benefits__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Scroll to benefit ' + (i + 1));
      dot.dataset.idx = i;
      dotsWrap.appendChild(dot);
    }
    dotsWrap.addEventListener('click', function(e) {
      var d = e.target.closest('.cl-benefits__dot');
      if (!d) return;
      var idx = parseInt(d.dataset.idx, 10);
      var card = cards[idx];
      if (card) track.scrollTo({ left: card.offsetLeft - 16, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }

  function updateControls() {
    prevBtn.hidden = track.scrollLeft <= 10;
    nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;

    var fadeLeft = document.querySelector('.cl-benefits__fade--left');
    if (fadeLeft) fadeLeft.style.opacity = track.scrollLeft > 10 ? '1' : '0';
    var fadeRight = document.querySelector('.cl-benefits__fade--right');
    if (fadeRight) fadeRight.style.opacity = (track.scrollLeft + track.clientWidth < track.scrollWidth - 10) ? '1' : '0';

    /* Update active dot based on scroll position */
    if (dotsWrap) {
      var dots = dotsWrap.querySelectorAll('.cl-benefits__dot');
      var closestIdx = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var dist = Math.abs(cards[i].offsetLeft - track.scrollLeft - 16);
        if (dist < closestDist) { closestDist = dist; closestIdx = i; }
      }
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === closestIdx); });
    }
  }

  prevBtn.addEventListener('click', function() {
    track.scrollBy({ left: -cardWidth * 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  nextBtn.addEventListener('click', function() {
    track.scrollBy({ left: cardWidth * 2, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  /* Reset scroll to start on load — prevents browser scroll restoration */
  track.scrollLeft = 0;

  track.addEventListener('scroll', updateControls, { passive: true });
  updateControls();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-faq-item]').forEach(function(item) {
    var btn = item.querySelector('.cl-faq__question');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var answer = item.querySelector('.cl-faq__answer');
      btn.setAttribute('aria-expanded', String(!expanded));
      if (answer) answer.hidden = expanded;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var hero = document.getElementById('collection-hero');
  if (!hero) return;
  var img = hero.querySelector('.cl-hero__img');
  if (!img) return;

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        var progress = -rect.top / (rect.height + window.innerHeight);
        var shift = progress * 80; /* max 80px shift — strong parallax */
        img.style.transform = 'translateY(' + shift + 'px)';
      }
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  var AVATAR_COLORS = [
    '#6366f1','#f43f5e','#0ea5e9','#10b981','#8b5cf6',
    '#f59e0b','#06b6d4','#ec4899','#84cc16','#14b8a6'
  ];

  var section = document.querySelector('[data-cl-reviews]');
  if (!section) return;

  var grid = section.querySelector('[data-cl-reviews-grid]');
  var loading = section.querySelector('[data-cl-reviews-loading]');
  var moreBtn = section.querySelector('[data-cl-reviews-more]');
  var statsEl = section.querySelector('[data-cl-reviews-stats]');
  var blurOverlay = section.querySelector('[data-cl-reviews-blur]');
  var shopDomain = section.dataset.shopDomain;
  var handle = section.dataset.collectionHandle;
  var minChars = parseInt(section.dataset.minChars, 10) || 200;
  var initialCount = parseInt(section.dataset.initialCount, 10) || 9;

  if (!handle || !shopDomain) return;

  function createStarsSVG(count) {
    var total = 5;
    var svg = '<svg width="' + (total * 18) + '" height="16" viewBox="0 0 ' + (total * 18) + ' 16" fill="none">';
    for (var i = 0; i < total; i++) {
      var x = i * 18;
      var fill = '#00b67a';
      var opacity = i < count ? '1' : '0.2';
      svg += '<polygon points="' + (x+8) + ',1 ' + (x+10.2) + ',5.8 ' + (x+15.5) + ',5.8 ' + (x+11.2) + ',9.4 ' + (x+12.8) + ',14.5 ' + (x+8) + ',11.5 ' + (x+3.2) + ',14.5 ' + (x+4.8) + ',9.4 ' + (x+0.5) + ',5.8 ' + (x+5.8) + ',5.8' + '" fill="' + fill + '" opacity="' + opacity + '"/>';
    }
    svg += '</svg>';
    return svg;
  }

  function verifiedBadgeSVG() {
    return '<svg width="14" height="14" viewBox="0 0 40 40" fill="none"><circle cx="20" cy="20" r="14" fill="#e8f4fd"/><path d="M19.998 3.094 14.638 0l-2.972 5.15H5.432v6.354L0 14.64 3.094 20 0 25.359l5.432 3.137v5.905h5.975L14.638 40l5.36-3.094L25.358 40l3.232-5.6h6.162v-6.01L40 25.359 36.905 20 40 14.641l-5.248-3.03v-6.46h-6.419L25.358 0l-5.36 3.094Zm7.415 11.225 2.254 2.287-11.43 11.5-6.835-6.93 2.244-2.258 4.587 4.581 9.18-9.18Z" fill="#42a5f5" fill-rule="evenodd"/></svg>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function buildCard(review, idx) {
    var bgColor = AVATAR_COLORS[idx % AVATAR_COLORS.length];
    var card = document.createElement('div');
    card.className = 'cl-reviews__card';

    var html = '';
    html += '<div class="cl-reviews__card-stars">' + createStarsSVG(review.stars) + '</div>';
    if (review.title) html += '<p class="cl-reviews__card-title">' + escapeHtml(review.title) + '</p>';
    if (review.body) html += '<p class="cl-reviews__card-quote">' + escapeHtml(review.body.substring(0, 500)) + (review.body.length > 500 ? '…' : '') + '</p>';

    html += '<div class="cl-reviews__card-footer">';
    html += '<div class="cl-reviews__card-avatar" style="background-color:' + bgColor + '">' + escapeHtml(review.initials) + '</div>';
    html += '<div class="cl-reviews__card-author-info">';
    html += '<span class="cl-reviews__card-author-name">' + escapeHtml(review.author) + '</span>';
    html += '<span class="cl-reviews__card-verified">' + verifiedBadgeSVG() + ' Verified Buyer</span>';
    if (review.date) html += '<span class="cl-reviews__card-date">' + escapeHtml(review.date) + '</span>';
    html += '</div></div>';

    card.innerHTML = html;
    return card;
  }

  var allReviews = [];
  var visibleCount = initialCount;
  var seenProductIds = {};

  function fetchJudgeMeReviews(products) {
    var reviewPromises = products.map(function(p) {
      var url = 'https://api.judge.me/reviews/reviews_for_widget'
        + '?url=' + shopDomain
        + '&shop_domain=' + shopDomain
        + '&platform=shopify'
        + '&page=1'
        + '&per_page=30'
        + '&product_id=' + p.id;

      return fetch(url)
        .then(function(r) { return r.ok ? r.json() : {}; })
        .then(function(json) {
          var reviews = [];
          /* Judge.me now answers with JSON review lists instead of rendered
             HTML (1 Oct 2026, MEL-1218). Same rules as the HTML path below:
             5 stars only, minimum body length. */
          if (!json.html) {
            (json.primary_language_reviews || json.reviews || []).forEach(function(r) {
              var stars = parseInt(r.rating, 10) || 0;
              if (stars < 5) return;
              var tmp = document.createElement('div');
              tmp.innerHTML = r.body_html || '';
              var body = tmp.textContent.trim();
              if (body.length < minChars) return;
              var author = (r.reviewer_name || '').trim();
              var nameParts = author.split(/\s+/);
              var initials = nameParts.length >= 2
                ? (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase()
                : author.substring(0, 2).toUpperCase();
              var d = r.created_at ? new Date(r.created_at) : null;
              reviews.push({
                stars: stars,
                title: (r.title || '').trim(),
                body: body,
                author: author,
                initials: initials,
                date: d && !isNaN(d) ? d.toLocaleDateString() : '',
                verified: true
              });
            });
            return reviews;
          }
          var temp = document.createElement('div');
          temp.innerHTML = json.html;
          var revEls = temp.querySelectorAll('.jdgm-rev');
          revEls.forEach(function(el) {
            var ratingEl = el.querySelector('.jdgm-rev__rating');
            var stars = 0;
            if (ratingEl) {
              var ds = ratingEl.getAttribute('data-score');
              stars = ds ? parseInt(ds, 10) : el.querySelectorAll('.jdgm-star.jdgm--on').length;
            } else {
              stars = el.querySelectorAll('.jdgm-star.jdgm--on').length;
            }
            if (stars < 5) return;

            var body = (el.querySelector('.jdgm-rev__body') || {}).textContent || '';
            body = body.trim();
            if (body.length < minChars) return;

            var title = (el.querySelector('.jdgm-rev__title') || {}).textContent || '';
            var author = (el.querySelector('.jdgm-rev__author') || {}).textContent || '';
            var date = (el.querySelector('.jdgm-rev__timestamp') || {}).textContent || '';
            var nameParts = author.trim().split(/\s+/);
            var initials = nameParts.length >= 2
              ? (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase()
              : (author.trim().substring(0, 2)).toUpperCase();

            reviews.push({
              stars: stars,
              title: title.trim(),
              body: body,
              author: author.trim(),
              initials: initials,
              date: date.trim(),
              verified: true
            });
          });
          return reviews;
        })
        .catch(function() { return []; });
    });

    return Promise.all(reviewPromises).then(function(results) {
      var out = [];
      results.forEach(function(batch) { out = out.concat(batch); });
      return out;
    });
  }

  fetch('/collections/' + handle + '/products.json?limit=50')
    .then(function(r) { return r.ok ? r.json() : { products: [] }; })
    .then(function(data) {
      var products = (data.products || []).slice(0, 8);
      products.forEach(function(p) { seenProductIds[p.id] = true; });
      return fetchJudgeMeReviews(products);
    })
    .then(function(collectionReviews) {
      allReviews = collectionReviews;

      /* SHOP-WIDE FALLBACK (Aug 12): collections whose products carry few or
         no reviews (curated bundles — reviews lost in the migration, re-import
         pending) rendered a near-empty band. When the collection's own
         products can't fill the initial grid, top up from /collections/all
         (best-selling order = the most-reviewed products), skipping products
         already queried. These are real store reviews, not filler — the band
         is store-social-proof, not per-product data. Collection reviews stay
         first in the list.  If everything fails we fall through with what we
         have; zero still hides the whole section below. */
      if (allReviews.length >= initialCount || handle === 'all') return;
      return fetch('/collections/all/products.json?limit=50')
        .then(function(r) { return r.ok ? r.json() : { products: [] }; })
        .then(function(data) {
          var extras = (data.products || []).filter(function(p) {
            return !seenProductIds[p.id];
          }).slice(0, 8);
          return fetchJudgeMeReviews(extras);
        })
        .then(function(storeReviews) {
          allReviews = allReviews.concat(storeReviews);
        })
        .catch(function() {});
    })
    .then(function() {
      (function finishRender() {
        if (loading) loading.style.display = 'none';

        if (allReviews.length === 0) {
          // No reviews → hide the whole section instead of rendering an empty
          // state on the storefront (an empty band reads as broken).
          var sectionWrap = grid.closest('.shopify-section') || grid.closest('[class*="cl-reviews"]');
          if (sectionWrap) sectionWrap.style.display = 'none';
          return;
        }

        /* Stats — Trustpilot stars-5.svg + store-wide review count.
           Marta (Aug 1): the count is STORE-wide, which reads oddly on a
           collection page. Two escape hatches, defaults unchanged:
           - store_count_alternative: custom text (e.g. a hashtag) replaces the
             "N+ verified 5-star reviews" line, stars kept.
           - hide_store_count: removes the stats row entirely. */
        if (statsEl) {
          var altText = section.dataset.storeCountAlt || '';
          var hideCount = section.dataset.hideStoreCount === 'true';
          if (hideCount && !altText) {
            statsEl.style.display = 'none';
          } else {
            var storeCount = section.dataset.storeReviewCount || '1,200';
            var tpStarsUrl = section.dataset.tpStarsUrl;
            var tpStarsImg = tpStarsUrl
              ? '<img src="' + tpStarsUrl + '" alt="Rated 5 out of 5 on Trustpilot" width="100" height="20" style="display:inline-block;vertical-align:middle" loading="lazy">'
              : '';
            var statsLabel = altText
              ? escapeHtml(altText)
              : storeCount + '+ verified 5-star reviews';
            statsEl.innerHTML = tpStarsImg + ' <span>' + statsLabel + '</span>';
          }
        }

        render();
      })();
    })
    .catch(function(err) {
      console.warn('[Collection Reviews]', err);
      if (loading) loading.textContent = 'Could not load reviews.';
    });

  function render() {
    grid.innerHTML = '';
    var visible = allReviews.slice(0, visibleCount);
    var hasMore = visibleCount < allReviews.length;

    visible.forEach(function(rev, i) {
      grid.appendChild(buildCard(rev, i));
    });

    if (moreBtn) moreBtn.hidden = !hasMore;
    if (blurOverlay) blurOverlay.style.display = hasMore ? 'block' : 'none';
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function() {
      visibleCount += 6;
      /* Expand masonry on mobile to show all visible cards */
      grid.classList.add('cl-reviews__masonry--expanded');
      render();
    });
  }

  /* Detect actual section background and update gradient CSS vars.
     Checks wrapper → element → body in order — handles transparent wrappers. */
  function setSectionBgVars() {
    var el = document.getElementById('collection-reviews');
    if (!el) return;
    var candidates = [el.closest('.shopify-section'), el, document.documentElement, document.body];
    var bg = null;
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i]) continue;
      var c = window.getComputedStyle(candidates[i]).backgroundColor;
      if (c && c !== 'rgba(0, 0, 0, 0)' && c !== 'transparent') { bg = c; break; }
    }
    if (bg) {
      el.style.setProperty('--section-bg', bg);
      var match = bg.match(/\d+/g);
      if (match && match.length >= 3) {
        var rgb = match.slice(0, 3).join(',');
        el.style.setProperty('--section-bg-semi', 'rgba(' + rgb + ',0.7)');
        el.style.setProperty('--section-bg-transparent', 'rgba(' + rgb + ',0)');
      }
    }
  }
  setSectionBgVars();
  /* Re-check after alternation script runs (multiple retries for deferred script) */
  setTimeout(setSectionBgVars, 100);
  setTimeout(setSectionBgVars, 300);
  setTimeout(setSectionBgVars, 600);
  setTimeout(setSectionBgVars, 1000);
  setTimeout(setSectionBgVars, 1500);
  /* Also re-check on any style mutation on our wrapper */
  var reviewsEl = document.getElementById('collection-reviews');
  if (reviewsEl) {
    var reviewWrapper = reviewsEl.closest('.shopify-section');
    if (reviewWrapper) {
      new MutationObserver(function() { setSectionBgVars(); }).observe(reviewWrapper, { attributes: true, attributeFilter: ['style'] });
    }
  }
  setTimeout(setSectionBgVars, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo-content"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrap = document.querySelector('[data-seo-wrap]');
  var content = document.querySelector('[data-seo-content]');
  var fade = document.querySelector('[data-seo-fade]');
  var toggle = document.querySelector('[data-seo-toggle]');
  var toggleText = document.querySelector('[data-seo-toggle-text]');
  if (!wrap || !content || !toggle) return;

  var text = content.textContent || '';
  if (text.length < 600) return; /* Only show read more for 600+ chars */

  wrap.classList.add('is-collapsed');
  fade.hidden = false;
  toggle.hidden = false;

  toggle.addEventListener('click', function() {
    wrap.classList.toggle('is-collapsed');
    var nowCollapsed = wrap.classList.contains('is-collapsed');
    if (toggleText) toggleText.textContent = nowCollapsed ? 'Read More' : 'Read Less';
    toggle.classList.toggle('is-expanded', !nowCollapsed);
    fade.hidden = !nowCollapsed;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sticky = document.querySelector('[data-sticky-cta]');
  if (!sticky) return;
  var subcats = document.getElementById('subcategories');
  var footer = document.querySelector('.footer-wrapper, footer');
  if (!subcats) return;

  function check() {
    var subBottom = subcats.getBoundingClientRect().bottom;
    var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    var show = subBottom < 0 && footerTop > window.innerHeight;
    sticky.hidden = false;
    /* pointer-events: none does not remove the <a> from the tab order or the
       a11y tree — inert does, while keeping the slide transition alive */
    sticky.inert = !show;
    sticky.classList.toggle('is-visible', show);
  }

  window.addEventListener('scroll', check, { passive: true });
  check();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-subcategories"] && !Shopify.designMode) return;
  try {
    
/* ── Filter Drawer toggle ── */
(function() {
  var toggle = document.querySelector('[data-filter-toggle]');
  var drawer = document.querySelector('[data-filter-drawer]');
  if (!toggle || !drawer) return;

  var teardownTimer = null;
  var lastFocused = null;
  var mainContent = document.querySelector('#MainContent, main');

  /* UNCLOSABLE-DRAWER FIX (Aug 12): open() inerts the main content, but the
     drawer used to LIVE inside <main> — inert applies to every descendant, so
     the drawer's own close button, overlay and Apply button all went dead the
     moment it opened (only ESC still worked, via the document listener).
     Reparenting the fixed-position drawer to <body> before any binding takes
     it out of the inert subtree; visually nothing changes. */
  if (mainContent && mainContent.contains(drawer)) {
    document.body.appendChild(drawer);
  }

  function open() {
    if (teardownTimer) { clearTimeout(teardownTimer); teardownTimer = null; }
    lastFocused = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function() { drawer.classList.add('is-open'); });
    /* Shared lock (assets/nf-scroll-lock.js) — body overflow:hidden does not
       hold here because html carries overflow-x: clip. */
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.lock('cl-filter-drawer');
    if (mainContent) mainContent.setAttribute('inert', '');
    var firstClose = drawer.querySelector('button[data-filter-close]');
    if (firstClose) firstClose.focus();
  }
  function close() {
    drawer.classList.remove('is-open');
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.unlock('cl-filter-drawer');
    if (mainContent) mainContent.removeAttribute('inert');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
    teardownTimer = setTimeout(function() {
      teardownTimer = null;
      drawer.hidden = true;
    }, 300);
  }

  toggle.addEventListener('click', open);
  drawer.querySelectorAll('[data-filter-close]').forEach(function(el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });

  /* Apply filters — build URL from checked inputs */
  var applyBtn = drawer.querySelector('[data-filter-apply]');
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var params = [];
      drawer.querySelectorAll('.cl-filter-drawer__checkbox:checked').forEach(function(cb) {
        params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
      });
      drawer.querySelectorAll('.cl-filter-drawer__price-input').forEach(function(input) {
        if (input.value) {
          params.push(encodeURIComponent(input.name) + '=' + encodeURIComponent(input.value));
        }
      });
      var base = window.location.pathname;
      window.location.href = base + (params.length ? '?' + params.join('&') : '');
    });
  }

})();

/* ── Sticky header shadow detection ──
   The bar pins at top: var(--nf-header-offset) (below the pinned site
   header), so the sentinel leaves the observed zone at that offset, not at
   the viewport edge — same pattern as main-collection's initStickyToolbar. */
(function() {
  var header = document.querySelector('.cl-subcats__header');
  if (!header || !('IntersectionObserver' in window)) return;
  var sentinel = document.createElement('div');
  sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;visibility:hidden;';
  header.parentNode.insertBefore(sentinel, header);
  var observer = null, lastOffset = -1;
  function build(offset) {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function(entries) {
      header.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 0, rootMargin: '-' + (offset + 1) + 'px 0px 0px 0px' });
    observer.observe(sentinel);
  }
  function measure() {
    var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nf-header-offset')) || 0;
    if (offset !== lastOffset) {
      lastOffset = offset;
      build(offset);
    }
  }
  measure();
  window.addEventListener('nf:header-offset', measure);
  window.addEventListener('resize', measure, { passive: true });
})();

/* ── Active filter chips: render from URL params on page load ── */
(function() {
  var chipsContainer = document.querySelector('[data-active-filters]');
  var chipsContainerMobile = document.querySelector('[data-active-filters-mobile]');
  if (!chipsContainer && !chipsContainerMobile) return;

  /* Read server-rendered label map from data attribute */
  var labelData = {};
  var src = chipsContainer || chipsContainerMobile;
  try { labelData = JSON.parse((src.dataset.filterLabels || '{}')); } catch(e) {}

  var urlParams = new URLSearchParams(window.location.search);
  var chipXSvg = '<svg class="cl-filter-chip__x" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg>';

  urlParams.forEach(function(value, key) {
    /* Skip non-filter params */
    if (['page', 'sort_by', 'view', 'preview_theme_id', 'q'].indexOf(key) !== -1) return;

    var lookupKey = key + '|||' + value;
    var entry = labelData[lookupKey];
    var humanLabel = entry ? entry.label : decodeURIComponent(value);
    var groupName = entry ? entry.group : '';

    /* For price range, show formatted using store money format */
    if (key.indexOf('.gte') !== -1 || key.indexOf('.lte') !== -1) {
      groupName = 'Price';
      var _priceFmt = document.body.getAttribute('data-money-format') || '${{amount}}';
      var _priceFormatted = _priceFmt.replace(/\{\{\s*amount\s*\}\}/, value)
                                     .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value)
                                     .replace(/\{\{\s*amount_no_decimals\s*\}\}/, value)
                                     .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, value);
      humanLabel = (key.indexOf('.gte') !== -1 ? 'Min ' : 'Max ') + _priceFormatted;
    }

    var chipLabel = humanLabel;

    function makeChip() {
      var chip = document.createElement('button');
      chip.className = 'cl-filter-chip';
      chip.type = 'button';
      chip.setAttribute('aria-label', 'Remove filter: ' + chipLabel);
      chip.innerHTML = '<span>' + chipLabel + '</span>' + chipXSvg;
      chip.addEventListener('click', function() {
        var newParams = new URLSearchParams(window.location.search);
        var all = newParams.getAll(key);
        newParams.delete(key);
        all.forEach(function(v) {
          if (v !== value) newParams.append(key, v);
        });
        var newUrl = window.location.pathname + (newParams.toString() ? '?' + newParams.toString() : '');
        window.location.href = newUrl;
      });
      return chip;
    }
    if (chipsContainer) chipsContainer.appendChild(makeChip());
    if (chipsContainerMobile) chipsContainerMobile.appendChild(makeChip());
  });
})();

/* ── Infinite scroll: load next page when trigger enters viewport ── */
(function() {
  var trigger = document.querySelector('[data-infinite-scroll]');
  if (!trigger) return;
  var grid = document.querySelector('[data-products-grid]');
  if (!grid) return;

  var loading = false;
  var nextUrl = trigger.dataset.nextUrl;

  function finishInfiniteScroll() {
    /* Terminal state (Aug 12): removed from the DOM, not just hidden — a
       hidden sentinel one stray display rule away from visible is what kept
       "Loading more products..." on screen after the last page (same lesson
       as main-collection's load-more button). */
    nextUrl = null;
    trigger.hidden = true;
    trigger.remove();
    observer.disconnect();
  }

  var observer = new IntersectionObserver(function(entries) {
    if (!entries[0].isIntersecting || loading || !nextUrl) return;
    loading = true;
    trigger.setAttribute('data-loading', '');

    fetch(nextUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-products-grid]');
        var newTrigger = doc.querySelector('[data-infinite-scroll]');

        var appended = [];
        if (newGrid) {
          var items = newGrid.querySelectorAll('.cl-subcats__product-item');
          items.forEach(function(item) {
            /* About to enter the viewport — eager images kill the blank-tile
               flash while the fade below masks the paint. */
            item.querySelectorAll('img[loading="lazy"]').forEach(function(img) { img.loading = 'eager'; });
            item.setAttribute('data-appear', '');
            grid.appendChild(item);
            appended.push(item);
          });
        }

        /* Soft landing: release opacity/translate next frame, 35ms stagger,
           then clear the delay so card hover stays snappy. Reduced-motion
           skips via the CSS media query. */
        requestAnimationFrame(function() { requestAnimationFrame(function() {
          appended.forEach(function(item, i) {
            var card = item.querySelector('.nf-card');
            if (card) card.style.transitionDelay = (i * 35) + 'ms';
            item.removeAttribute('data-appear');
          });
          setTimeout(function() {
            appended.forEach(function(item) {
              var card = item.querySelector('.nf-card');
              if (card) card.style.transitionDelay = '';
            });
          }, appended.length * 35 + 400);
        }); });

        if (appended.length > 0 && newTrigger && newTrigger.dataset.nextUrl) {
          nextUrl = newTrigger.dataset.nextUrl;
        } else {
          /* Last page, empty page, or malformed response — stop for good. */
          finishInfiniteScroll();
        }
        loading = false;
        trigger.removeAttribute('data-loading');
      })
      .catch(function() {
        loading = false;
        trigger.removeAttribute('data-loading');
        finishInfiniteScroll();
      });
  }, { rootMargin: '400px' });

  observer.observe(trigger);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-video"] && !Shopify.designMode) return;
  try {
    
(function() {
  var player = document.querySelector('[data-video-player]');
  if (!player) return;

  var playBtn = player.querySelector('[data-video-play]');
  var nativeVideo = player.querySelector('[data-video-native]');
  var poster = player.querySelector('[data-video-poster]');
  var iframeWrap = player.querySelector('[data-video-iframe]');
  var controlsWrap = player.querySelector('[data-video-controls]');
  var progressWrap = player.querySelector('[data-video-progress]');
  var progressBar = player.querySelector('[data-video-progress-bar]');
  var muteBtn = player.querySelector('[data-video-mute]');
  var speedBtn = player.querySelector('[data-video-speed]');
  var fullscreenBtn = player.querySelector('[data-video-fullscreen]');
  var timeEl = player.querySelector('[data-video-time]');

  if (!playBtn) return;

  function fmtTime(s) {
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  /* Solution A: Local video */
  if (nativeVideo) {
    var isPlaying = false;
    var speeds = [1, 1.2, 1.5, 2];
    var speedIdx = 0;

    playBtn.addEventListener('click', function() {
      nativeVideo.play();
      nativeVideo.muted = false;
      playBtn.hidden = true;
      if (controlsWrap) controlsWrap.hidden = false;
      isPlaying = true;
    });

    nativeVideo.addEventListener('click', function() {
      if (isPlaying) {
        nativeVideo.pause();
        playBtn.hidden = false;
        isPlaying = false;
      } else {
        nativeVideo.play();
        playBtn.hidden = true;
        isPlaying = true;
      }
    });

    nativeVideo.addEventListener('timeupdate', function() {
      if (progressBar && nativeVideo.duration) {
        var pct = (nativeVideo.currentTime / nativeVideo.duration) * 100;
        progressBar.style.width = pct + '%';
      }
      if (timeEl && nativeVideo.duration) {
        timeEl.textContent = fmtTime(nativeVideo.currentTime) + ' / ' + fmtTime(nativeVideo.duration);
      }
    });

    nativeVideo.addEventListener('ended', function() {
      playBtn.hidden = false;
      if (controlsWrap) controlsWrap.hidden = true;
      isPlaying = false;
    });

    /* Progress bar seeking */
    if (progressWrap) {
      progressWrap.addEventListener('click', function(e) {
        if (!nativeVideo.duration) return;
        var rect = progressWrap.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        nativeVideo.currentTime = pct * nativeVideo.duration;
      });
    }

    /* Speed control */
    if (speedBtn) {
      speedBtn.addEventListener('click', function() {
        speedIdx = (speedIdx + 1) % speeds.length;
        nativeVideo.playbackRate = speeds[speedIdx];
        speedBtn.textContent = speeds[speedIdx] + 'x';
      });
    }

    /* Mute */
    if (muteBtn) {
      muteBtn.addEventListener('click', function() {
        nativeVideo.muted = !nativeVideo.muted;
        muteBtn.innerHTML = nativeVideo.muted
          ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>'
          : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></svg>';
      });
    }

    /* Fullscreen */
    if (fullscreenBtn) {
      fullscreenBtn.addEventListener('click', function() {
        if (nativeVideo.requestFullscreen) nativeVideo.requestFullscreen();
        else if (nativeVideo.webkitEnterFullscreen) nativeVideo.webkitEnterFullscreen();
      });
    }
    return;
  }

  /* Solution B: YouTube / Vimeo embed */
  if (iframeWrap) {
    function startEmbed() {
      var iframe = iframeWrap.querySelector('iframe');
      if (iframe && iframe.dataset.src) iframe.src = iframe.dataset.src;
      playBtn.hidden = true;
      if (poster) poster.hidden = true;
      iframeWrap.hidden = false;
    }
    playBtn.addEventListener('click', startEmbed);
    if (poster) poster.addEventListener('click', startEmbed);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-accordion"] && !Shopify.designMode) return;
  try {
    
  function initFeatureAccordion(root) {
      var items = root.querySelectorAll('[data-feature-item]');
      var slides = root.querySelectorAll('[data-media-slide]');
      if (!items.length) return;

      /* Collapsed panels stay in the layout (grid-rows trick) so their CTA
         links would remain tabbable while invisible — inert removes them
         from the tab order + a11y tree without breaking the transition. */
      function setPanelInert(item, isActive) {
        var panel = item.querySelector('.fa-accordion__item-panel');
        if (panel) panel.inert = !isActive;
      }
      items.forEach(function (item) {
        setPanelInert(item, item.classList.contains('fa-accordion__item--open'));
      });

      function activate(targetIndex) {
        items.forEach(function (item, i) {
          var trigger = item.querySelector('[data-feature-trigger]');
          var isActive = i === targetIndex;
          item.classList.toggle('fa-accordion__item--open', isActive);
          if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          setPanelInert(item, isActive);
          /* `hidden` attribute removed — visibility now driven by .--open class
             via grid-row transition so the expand/collapse animates smoothly. */
        });
        slides.forEach(function (slide, i) {
          var isActive = i === targetIndex;
          slide.classList.toggle('fa-accordion__media-slide--active', isActive);
          if (isActive) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
      }

      items.forEach(function (item, i) {
        var trigger = item.querySelector('[data-feature-trigger]');
        if (!trigger) return;

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('fa-accordion__item--open');
          // Allow toggling closed only on mobile (where image is above)
          // On desktop, always keep at least one open so the image stays anchored.
          if (isOpen && window.matchMedia('(max-width: 989px)').matches) {
            item.classList.remove('fa-accordion__item--open');
            trigger.setAttribute('aria-expanded', 'false');
            setPanelInert(item, false);
            return;
          }
          activate(i);
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Home' && e.key !== 'End') return;
          e.preventDefault();
          var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-feature-trigger]'));
          var current = triggers.indexOf(trigger);
          var next = current;
          if (e.key === 'ArrowDown') next = (current + 1) % triggers.length;
          else if (e.key === 'ArrowUp') next = (current - 1 + triggers.length) % triggers.length;
          else if (e.key === 'Home') next = 0;
          else if (e.key === 'End') next = triggers.length - 1;
          triggers[next].focus();
        });
      });
  }

  function bootFeatureAccordions() {
    document.querySelectorAll('[data-feature-accordion]').forEach(initFeatureAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFeatureAccordions);
  } else {
    bootFeatureAccordions();
  }

  // Shopify theme-editor: re-init when a section is reloaded
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-feature-accordion]');
    if (section) initFeatureAccordion(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-content"] && !Shopify.designMode) return;
  try {
    
/**
 * <legal-longform>
 * Builds a table of contents from the headings inside merchant rich text.
 * Shopify richtext emits no ids, so ids are slugified from the heading text
 * here, de-duplicated against each other and against ids already on the page.
 */
if (!customElements.get('legal-longform')) {
  class LegalLongform extends HTMLElement {
    #items = [];
    #links = [];
    #ticking = false;
    #mobileQuery = null;
    #onScroll = null;
    #onBreakpoint = null;

    connectedCallback() {
      this.bodyEl = this.querySelector('[data-legal-body]');
      if (!this.bodyEl) return;

      this.#wrapTables();

      this.nav = this.querySelector('[data-legal-toc]');
      this.panel = this.querySelector('[data-legal-toc-panel]');
      this.disclosure = this.querySelector('[data-legal-toc-disclosure]');
      if (!this.nav || !this.panel || !this.disclosure) return;

      this.#buildToc();
    }

    disconnectedCallback() {
      if (this.#onScroll) window.removeEventListener('scroll', this.#onScroll);
      if (this.#onBreakpoint && this.#mobileQuery) {
        this.#mobileQuery.removeEventListener('change', this.#onBreakpoint);
      }
    }

    /** @returns {number} heading level, e.g. 2 for <h2> */
    #levelOf(heading) {
      return Number(heading.tagName.slice(1));
    }

    /**
     * Slugify heading text into a unique id.
     * @param {string} text
     * @param {Set<string>} taken
     * @returns {string}
     */
    #uniqueId(text, taken) {
      const base =
        text
          .trim()
          .toLowerCase()
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 60) || 'section';

      let candidate = base;
      let suffix = 2;
      while (taken.has(candidate) || document.getElementById(candidate)) {
        candidate = base + '-' + suffix;
        suffix += 1;
      }
      return candidate;
    }

    #buildToc() {
      const headings = Array.from(this.bodyEl.querySelectorAll('h2, h3, h4, h5, h6')).filter(
        (heading) => heading.textContent.trim() !== ''
      );
      // No headings in the rich text: leave the nav hidden so there is no gap.
      if (headings.length === 0) return;

      const topLevel = Math.min(...headings.map((heading) => this.#levelOf(heading)));
      const taken = new Set();

      for (const heading of headings) {
        const level = this.#levelOf(heading);
        // Two levels deep is enough for a usable list.
        if (level > topLevel + 1) continue;
        if (!heading.id) heading.id = this.#uniqueId(heading.textContent, taken);
        taken.add(heading.id);
        this.#items.push({ heading: heading, level: level });
      }
      if (this.#items.length === 0) return;

      const list = document.createElement('ol');
      list.className = 'legal-toc__list';
      let nested = null;

      for (const item of this.#items) {
        const listItem = document.createElement('li');
        listItem.className = 'legal-toc__item';

        const link = document.createElement('a');
        link.className = 'legal-toc__link';
        link.href = '#' + item.heading.id;
        link.textContent = item.heading.textContent.trim();
        listItem.appendChild(link);
        this.#links.push(link);

        if (item.level === topLevel) {
          list.appendChild(listItem);
          nested = null;
          continue;
        }

        if (!nested) {
          nested = document.createElement('ol');
          nested.className = 'legal-toc__list legal-toc__list--nested';
          let parent = list.lastElementChild;
          if (!parent) {
            parent = document.createElement('li');
            parent.className = 'legal-toc__item';
            list.appendChild(parent);
          }
          parent.appendChild(nested);
        }
        nested.appendChild(listItem);
      }

      this.panel.appendChild(list);
      this.nav.hidden = false;
      this.classList.add('is-toc-ready');

      this.nav.addEventListener('click', this.#handleClick.bind(this));
      this.#watchBreakpoint();
      this.#trackActive();
      this.#restoreHash();
    }

    #wrapTables() {
      for (const table of this.bodyEl.querySelectorAll('table')) {
        const parent = table.parentElement;
        if (!parent || parent.classList.contains('legal-body__table-scroll')) continue;

        const scroller = document.createElement('div');
        scroller.className = 'legal-body__table-scroll';
        parent.insertBefore(scroller, table);
        scroller.appendChild(table);

        // Only make it a keyboard-reachable region when it actually scrolls.
        if (scroller.scrollWidth > scroller.clientWidth) {
          const caption = table.querySelector('caption');
          scroller.setAttribute('role', 'region');
          scroller.setAttribute('tabindex', '0');
          scroller.setAttribute(
            'aria-label',
            caption && caption.textContent.trim() ? caption.textContent.trim() : 'Table'
          );
        }
      }
    }

    #prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    #handleClick(event) {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;

      const id = decodeURIComponent(link.hash.slice(1));
      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({
        behavior: this.#prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start'
      });

      // Keep the heading as the next tab stop for keyboard users.
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', link.getAttribute('href'));
      }

      if (this.#mobileQuery && this.#mobileQuery.matches) this.disclosure.open = false;
    }

    #watchBreakpoint() {
      this.#mobileQuery = window.matchMedia('(max-width: 989px)');
      this.#onBreakpoint = () => {
        this.disclosure.open = !this.#mobileQuery.matches;
      };
      this.#onBreakpoint();
      this.#mobileQuery.addEventListener('change', this.#onBreakpoint);
    }

    #trackActive() {
      const update = () => {
        this.#ticking = false;
        let active = null;
        for (const item of this.#items) {
          if (item.heading.getBoundingClientRect().top > 120) break;
          active = item;
        }
        for (const link of this.#links) {
          const isActive = active !== null && link.hash === '#' + active.heading.id;
          link.classList.toggle('is-active', isActive);
          if (isActive) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        }
      };

      this.#onScroll = () => {
        if (this.#ticking) return;
        this.#ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', this.#onScroll, { passive: true });
      update();
    }

    #restoreHash() {
      // Ids only exist after this script runs, so a deep link never resolved.
      const hash = window.location.hash;
      if (hash.length < 2) return;
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      if (target) target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }
  }

  customElements.define('legal-longform', LegalLongform);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function() {
  var copyBtn = document.querySelector('[data-share-copy]');
  var shareBtn = document.querySelector('[data-share-native]');
  if (!copyBtn && !shareBtn) return;

  function showCopied() {
    var text = document.querySelector('[data-share-copy-text]');
    if (!text) return;
    var original = text.textContent;
    text.textContent = 'Copied!';
    setTimeout(function() { text.textContent = original; }, 2000);
  }

  function copyUrl() {
    var url = window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(showCopied, function() {
        legacyCopy(url);
      });
    } else {
      legacyCopy(url);
    }
  }

  function legacyCopy(url) {
    var ta = document.createElement('textarea');
    ta.value = url;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    showCopied();
  }

  if (copyBtn) copyBtn.addEventListener('click', copyUrl);

  /* Native share where the platform supports it; falls back to copying
     the link (with the Copy Link feedback state) where it does not. */
  if (shareBtn) {
    if (navigator.share) {
      shareBtn.hidden = false;
      shareBtn.addEventListener('click', function() {
        navigator.share({ title: document.title, url: window.location.href })
          .catch(function(err) {
            if (!err || err.name !== 'AbortError') copyUrl();
          });
      });
    }
    /* No navigator.share: button stays hidden, Copy Link covers the job. */
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function() {
  var page = document.querySelector('[data-cart-page]');
  if (!page) return;

  /* ── Money formatting ──
     window.NanoleafTheme.formatMoney (layout/theme.liquid) is market-aware:
     correct symbol, decimals, and separators per active currency + locale.
     The Intl fallback reads the same body attributes so nothing is hardcoded. */
  function formatMoney(cents) {
    if (window.NanoleafTheme && window.NanoleafTheme.formatMoney) {
      return window.NanoleafTheme.formatMoney(cents);
    }
    var currency = document.body.getAttribute('data-active-currency') || 'USD';
    var locale = document.body.getAttribute('data-locale') || document.documentElement.lang || 'en';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  /* ── Quantity +/- buttons ──
     These delegated handlers read the input at click time (no stale-closure
     bug), and the input is updated optimistically before the request queues,
     so rapid clicks accumulate on screen and only the final value is sent. */
  page.addEventListener('click', function(e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var wrap = (minus || plus).closest('[data-qty-wrap]');
    var input = wrap.querySelector('[data-qty-input]');
    var val = parseInt(input.value, 10) || 1;

    if (minus) val = Math.max(1, val - 1);
    if (plus) val = Math.min(99, val + 1);

    input.value = val;
    queueQuantity(input.dataset.key, val);
  });

  /* ── Quantity input direct change ── */
  page.addEventListener('change', function(e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    if (val > 99) val = 99;
    input.value = val;
    queueQuantity(input.dataset.key, val);
  });

  /* ── Remove button ── */
  page.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    queueQuantity(btn.dataset.removeKey, 0);
  });

  /* ── Request hygiene ──
     The old code fired one request per click and then reloaded the whole page
     on every response (audit C5). One timer and one in-flight request per line
     item now: 250ms debounce collapses click bursts, AbortController cancels a
     superseded request so the last value always wins, and the DOM is patched
     in place from the returned cart instead of reloading.

     is-updating is applied when the request actually fires, not while the
     debounce is pending — the class sets pointer-events:none on the line, and
     applying it on the first click would block the rapid clicks the debounce
     exists to absorb. */
  var qtyTimers = {};
  var qtyControllers = {};
  var freeThresholdCents = parseInt(page.dataset.freeThreshold, 10) || 0;

  function itemEl(key) {
    return page.querySelector('[data-cart-page-item][data-item-key="' + key + '"]');
  }

  function queueQuantity(key, qty) {
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function() {
      qtyTimers[key] = null;
      updateQuantity(key, qty);
    }, 250);
  }

  function updateQuantity(key, qty) {
    if (qtyControllers[key]) qtyControllers[key].abort();
    var controller = new AbortController();
    qtyControllers[key] = controller;

    var item = itemEl(key);
    if (item) item.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
      signal: controller.signal
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().catch(function() { return {}; }).then(function(body) {
          var msg = (body && (body.description || body.message))
            || (r.status === 429
                  ? (page.dataset.i18nCartBusy || 'Too many updates at once. Give it a second and try again.')
                  : (page.dataset.i18nCartError || 'Could not update your cart.'));
          throw new Error(msg);
        });
      }
      return r.json();
    })
    .then(function(cart) {
      if (controller.signal.aborted) return;   // a newer request already won
      renderCartState(cart);
    })
    .catch(function(err) {
      if (err && err.name === 'AbortError') return;   // superseded, not a failure
      console.error('Cart update failed:', err);
      if (item) item.classList.remove('is-updating');
      showCartError(err && err.message ? err.message : (page.dataset.i18nCartError || 'Could not update your cart.'));
      resyncFromServer();   // never leave a quantity on screen the server rejected
    });
  }

  /* ── Patch the page in place from a /cart/change.js or /cart.js payload ── */
  function renderCartState(cart) {
    if (cart.item_count === 0) {
      /* Sole reload exception: the empty-cart state lives in the Liquid
         {% else %} branch (translated strings + route URLs unavailable to this
         tag), and swapping it in would mean tearing down the two-column layout
         and upsell grid too. One reload on the last-item removal is terminal —
         there is nothing left on the page to interact with. */
      window.location.reload();
      return;
    }

    var byKey = {};
    cart.items.forEach(function(it) { byKey[it.key] = it; });

    page.querySelectorAll('[data-cart-page-item]').forEach(function(el) {
      var it = byKey[el.dataset.itemKey];
      if (!it) { removeLine(el); return; }
      el.classList.remove('is-updating');

      /* Server-clamped quantity (inventory caps etc.) is the truth — but do
         not clobber the optimistic value while a newer update is still queued
         for this line. */
      var input = el.querySelector('[data-qty-input]');
      if (input && !qtyTimers[el.dataset.itemKey]) input.value = it.quantity;

      var lineTotal = el.querySelector('.cart-pg__item-line-total');
      if (lineTotal) lineTotal.textContent = formatMoney(it.final_line_price);
      var unitPrice = el.querySelector('.cart-pg__item-price');
      if (unitPrice) unitPrice.textContent = formatMoney(it.final_price);
    });

    var countEl = page.querySelector('[data-cart-page-count]');
    if (countEl) countEl.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? (page.dataset.i18nItem || 'item') : (page.dataset.i18nItems || 'items')) + ')';

    var subtotalEl = page.querySelector('[data-cart-page-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    var checkoutTotal = page.querySelector('[data-checkout-total]');
    if (checkoutTotal) checkoutTotal.textContent = formatMoney(cart.total_price);

    updateShipping(cart.total_price);

    /* Header badge sync. The brief suggested dispatching cart:updated, but the
       drawer's listener for that event is fetchCart() + openDrawer() — firing
       it here would pop the drawer open over the cart page on every quantity
       change. So the badge is set the exact way the drawer itself sets it
       (textContent on .nf-header__cart-badge); the drawer's own cache
       self-corrects on open via its silent fetchCartAndRender(). */
    document.querySelectorAll('.nf-header__cart-badge').forEach(function(b) {
      b.textContent = cart.item_count;
    });
  }

  function removeLine(el) {
    /* .cart-pg__item already has transition: opacity 0.2s ease */
    el.style.opacity = '0';
    el.style.pointerEvents = 'none';
    setTimeout(function() {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, 200);
  }

  /* ── Free-shipping threshold, mirrored from the Liquid above ── */
  function updateShipping(totalCents) {
    /* 0 = this currency has no free-shipping rate (snippets/
       free-ship-threshold.liquid). Without this branch `total >= 0` is true
       for every cart and the summary claimed "Free" on the US market. */
    if (freeThresholdCents <= 0) {
      var valueEl0 = page.querySelector('[data-shipping-value]');
      if (valueEl0) valueEl0.textContent = valueEl0.dataset.i18nCalculated || 'Calculated at checkout';
      var note0 = page.querySelector('[data-shipping-note]');
      if (note0) note0.hidden = true;
      return;
    }

    var qualified = totalCents >= freeThresholdCents;

    var valueEl = page.querySelector('[data-shipping-value]');
    if (valueEl) {
      if (qualified) {
        valueEl.innerHTML = '<span style="color:#2d8a23;font-weight:600">' + (page.dataset.i18nFree || 'Free') + '</span>';
      } else {
        valueEl.textContent = valueEl.dataset.i18nCalculated || 'Calculated at checkout';
      }
    }

    var note = page.querySelector('[data-shipping-note]');
    if (note) {
      note.hidden = qualified;
      if (!qualified) {
        var remaining = note.querySelector('[data-shipping-remaining]');
        if (remaining) remaining.textContent = formatMoney(freeThresholdCents - totalCents);
      }
    }
  }

  /* ── Visible error near the items list ── */
  function showCartError(message) {
    var box = page.querySelector('[data-cart-error]');
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-cart-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'cart-pg__error';
      var itemsList = page.querySelector('[data-cart-page-items]');
      if (itemsList && itemsList.parentNode) {
        itemsList.parentNode.insertBefore(box, itemsList);
      } else {
        page.prepend(box);
      }
    }
    box.textContent = message;
    box.hidden = false;
    clearTimeout(showCartError._t);
    showCartError._t = setTimeout(function() { box.hidden = true; }, 5000);
  }

  /* ── Resync display with what the server actually holds ── */
  var resyncController = null;
  function resyncFromServer() {
    if (resyncController) resyncController.abort();
    resyncController = new AbortController();
    fetch('/cart.js', { signal: resyncController.signal })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(renderCartState)
      .catch(function() {
        /* Resync itself failed (likely the same 429) — at least unlock the
           lines so the shopper can retry. */
        page.querySelectorAll('[data-cart-page-item].is-updating').forEach(function(el) {
          el.classList.remove('is-updating');
        });
      });
  }

  /* ── Order note save ── */
  var noteArea = page.querySelector('[data-order-note]');
  if (noteArea) {
    var noteTimer;
    noteArea.addEventListener('input', function() {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteArea.value })
        });
      }, 600);
    });
  }

  /* ── Discount code ──
     This button was rendered and styled but had no handler anywhere in the
     theme, so clicking Apply did nothing at all.

     Classic Liquid storefronts cannot validate or apply a discount code
     through the Ajax Cart API: codes are a checkout-time concept. The only
     supported path is the /discount/<code> endpoint, which stores the code on
     the session so checkout picks it up. We redirect back to the cart rather
     than straight to checkout, because someone clicking Apply on their cart
     page expects to stay on their cart, not to be pushed into checkout. */
  var discountBtn = page.querySelector('[data-discount-apply]');
  var discountInput = page.querySelector('[data-discount-input]');
  var discountHint = page.querySelector('[data-discount-hint]');

  function showHint(msg) {
    if (!discountHint) return;
    discountHint.textContent = msg;
    discountHint.hidden = false;
  }

  function applyDiscount() {
    var code = (discountInput.value || '').trim();
    if (!code) {
      showHint(page.dataset.i18nDiscountEmpty || 'Enter a code first.');
      discountInput.focus();
      return;
    }
    discountBtn.disabled = true;
    showHint(page.dataset.i18nDiscountApplying || 'Applying your code...');

    // Market root arrives via data attribute because {% javascript %} does not
    // render Liquid. It is already stripped of its trailing slash, so this
    // cannot build a "//discount/" protocol-relative URL on the primary market.
    var root = discountBtn.dataset.marketRoot || '';
    var back = root + '/cart';
    window.location.href = root + '/discount/' + encodeURIComponent(code)
      + '?redirect=' + encodeURIComponent(back);
  }

  if (discountBtn && discountInput) {
    discountBtn.addEventListener('click', applyDiscount);
    // Enter inside the field should submit, not do nothing.
    discountInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function() {
  const section = document.querySelector('[data-collection-grid]');
  if (!section) return;

  /* MEL-1015 follow-up (sales collection, Aug 11): the gallery <img> ships
     lazy AND display:none, and a hidden lazy image is never fetched — it can
     never intersect the viewport. Switching to Gallery therefore flipped the
     CSS but showed blank tiles (WebKit never recovers; Chrome only after a
     further scroll; background tabs never). Promoting the images to eager the
     moment gallery view needs them forces the fetch, while catalogue-only
     visitors still never download the second image. Hoisted so both the
     toggle and the AJAX grid rebuilds below can call it. */
  function forceLoadGalleryImages() {
    section.querySelectorAll('.nf-card__img--gallery[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  }

  /* Task 5 (Aug 12): the toggle only earns its place when the CURRENT card set
     has at least one gallery image to swap to. Liquid already gates the
     initial render; this re-check runs after every AJAX filter/sort swap and
     after Load more appends (a filtered set can lose/regain gallery shots). */
  function updateViewToggleVisibility() {
    const toggle = section.querySelector('[data-view-toggle]');
    if (!toggle) return;
    toggle.hidden = !section.querySelector('[data-grid] .nf-card__img--gallery');
  }

  /* Re-applies the active view mode to a freshly swapped-in grid (AJAX
     filter/sort replaces the [data-grid] node, dropping its attributes). */
  function syncGridViewState() {
    const activePill = section.querySelector('[data-view-pill].cl-grid__view-pill--active');
    const freshGrid = section.querySelector('[data-grid]');
    if (freshGrid && activePill) {
      freshGrid.dataset.viewMode = activePill.dataset.viewPill;
      if (activePill.dataset.viewPill === 'gallery') {
        freshGrid.setAttribute('data-gallery-ready', '');
        /* Swapped-in cards arrive lazy + hidden again — same fetch trap */
        forceLoadGalleryImages();
      }
    }
    updateViewToggleVisibility();
    /* The deal band lives on the grid node the swap just replaced: the fresh
       cards arrive in collection order with light-scheme markup. */
    if (window.NanoleafSaleBand) window.NanoleafSaleBand.paint();
    if (window.NanoleafMarketOrder) window.NanoleafMarketOrder.apply();
    if (window.NanoleafPriceSort) window.NanoleafPriceSort.apply();
  }

  /* ════════════════════════════════════════
     SIDEBAR DRAWER (mobile only)
     ════════════════════════════════════════ */
  const sidebar = section.querySelector('[data-filter-sidebar]');
  const overlay = section.querySelector('[data-filter-overlay]');
  const toggleBtn = section.querySelector('[data-filter-toggle]');
  const closeBtn = section.querySelector('[data-filter-close]');

  let _filterLastFocus = null;
  function trapTab(container, e) {
    if (e.key !== 'Tab') return;
    var f = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  let _overlayTeardownTimer = null;
  function openDrawer() {
    if (!sidebar) return;
    if (_overlayTeardownTimer) { clearTimeout(_overlayTeardownTimer); _overlayTeardownTimer = null; }
    _filterLastFocus = document.activeElement;
    sidebar.removeAttribute('inert');
    sidebar.dataset.open = 'true';
    if (closeBtn) closeBtn.focus();
    if (overlay) {
      overlay.hidden = false;
      overlay.dataset.open = 'true';
    }
    document.body.dataset.filterDrawerOpen = 'true';
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.lock('filter-drawer');
  }
  function closeDrawer() {
    if (!sidebar) return;
    sidebar.dataset.open = 'false';
    if (overlay) {
      overlay.dataset.open = 'false';
      _overlayTeardownTimer = setTimeout(() => { _overlayTeardownTimer = null; overlay.hidden = true; }, 300);
    }
    document.body.removeAttribute('data-filter-drawer-open');
    if (window.NanoleafScrollLock) window.NanoleafScrollLock.unlock('filter-drawer');
    sidebar.setAttribute('inert', '');
    if (_filterLastFocus && _filterLastFocus.focus) { _filterLastFocus.focus(); _filterLastFocus = null; }
  }

  if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn)  closeBtn.addEventListener('click', closeDrawer);
  /* Drawer at all viewports: closed = out of the tab order */
  if (sidebar) { sidebar.setAttribute('inert', ''); sidebar.addEventListener('keydown', function(e) { trapTab(sidebar, e); }); }
  if (overlay)   overlay.addEventListener('click', closeDrawer);

  /* ESC closes drawer */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sidebar?.dataset.open === 'true') closeDrawer();
  });

  /* ════════════════════════════════════════
     AJAX FILTER + SORT — no full page reload
     Apply/Sort/chip-remove all use fetch() to swap the product grid + chips
     + count without reloading. URL stays in sync via history.pushState, so
     Back/Forward walk the filter steps (popstate re-render below).
     ════════════════════════════════════════ */
  const form = section.querySelector('[data-filter-form]');
  const sortSelect = section.querySelector('[data-sort-select]');
  let filterAbortCtrl = null;
  const collectionPath = window.location.pathname;

  /* Shopify builds the chip and "Clear all" URLs itself, and they only ever
     carry filter + sort_by params — "Clear all" is the bare collection URL.
     Our Catalogue/Gallery mode lives in `img`, which Shopify knows nothing
     about, so (Iris, Aug 12) removing one chip in Gallery view dropped
     img=gallery from the URL, and "Clear all" reset the sort while the Sort
     dropdown kept displaying the old value — the control and the grid
     disagreed until a reload. Re-attach whatever the current URL carries;
     clearing FILTERS must not clear the sort or the image mode. */
  function withViewParams(url) {
    const cur = new URL(window.location.href);
    const next = new URL(url, window.location.origin);
    if (cur.searchParams.get('img') === 'gallery' && !next.searchParams.has('img')) {
      next.searchParams.set('img', 'gallery');
    }
    const sort = cur.searchParams.get('sort_by');
    if (sort && !next.searchParams.has('sort_by')) next.searchParams.set('sort_by', sort);
    return next.toString();
  }

  function applyAjaxNavigation(url, { closeOnSuccess = false, push = true, scroll = true } = {}) {
    filterAbortCtrl?.abort();
    filterAbortCtrl = new AbortController();
    section.dataset.loading = 'true';

    return fetch(url, { signal: filterAbortCtrl.signal, headers: { 'Accept': 'text/html' } })
      .then((r) => {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[data-collection-grid]');
        if (!newSection) throw new Error('No grid in response');

        /* Swap parts we care about: grid, count, chips, sidebar form (filter counts).
           MEL fix (mobile filtering, Aug 1): the old loop could only replace or
           remove — an element absent on the CURRENT page could never appear.
           Symptoms: applying the first filter never showed the chips row or the
           badge; filtering to an empty result then clearing never brought the
           grid back. Each part now has an insertion point for the missing→present
           direction. Grid and empty-state are one mutually-exclusive slot. */

        /* 1. Grid / empty-state — same slot in .cl-grid__main */
        const oldSlot = section.querySelector('[data-grid], .cl-grid__empty');
        const newSlot = newSection.querySelector('[data-grid], .cl-grid__empty');
        if (oldSlot && newSlot) oldSlot.replaceWith(newSlot.cloneNode(true));

        /* 2. Load more — right after the grid slot */
        const oldLM = section.querySelector('[data-load-more]');
        const newLM = newSection.querySelector('[data-load-more]');
        if (oldLM && newLM) oldLM.replaceWith(newLM.cloneNode(true));
        else if (oldLM && !newLM) oldLM.remove();
        else if (!oldLM && newLM) {
          const g = section.querySelector('[data-grid], .cl-grid__empty');
          if (g) g.after(newLM.cloneNode(true));
        }

        /* 3. Chips row — right before the grid slot */
        const oldChips = section.querySelector('[data-filter-chips]');
        const newChips = newSection.querySelector('[data-filter-chips]');
        if (oldChips && newChips) oldChips.replaceWith(newChips.cloneNode(true));
        else if (oldChips && !newChips) oldChips.remove();
        else if (!oldChips && newChips) {
          const g = section.querySelector('[data-grid], .cl-grid__empty');
          if (g) g.before(newChips.cloneNode(true));
        }

        /* 4. Filter count badge — inside the toggle button */
        const oldBadge = section.querySelector('[data-filter-badge]');
        const newBadge = newSection.querySelector('[data-filter-badge]');
        if (oldBadge && newBadge) oldBadge.replaceWith(newBadge.cloneNode(true));
        else if (oldBadge && !newBadge) oldBadge.remove();
        else if (!oldBadge && newBadge) {
          const toggle = section.querySelector('[data-filter-toggle]');
          if (toggle) toggle.appendChild(newBadge.cloneNode(true));
        }

        /* 5. Straight swaps (always present when their feature is on) */
        for (const sel of ['[data-filter-form]', '.cl-grid__count']) {
          const oldEl = section.querySelector(sel);
          const newEl = newSection.querySelector(sel);
          if (oldEl && newEl) oldEl.replaceWith(newEl.cloneNode(true));
          else if (oldEl && !newEl) oldEl.remove();
        }

        /* Update browser URL without reload.
           PUSH, not replace (Iris, Aug 12): every filter, sort and chip used
           replaceState, so the whole filtering session collapsed into a single
           history entry — pressing Back after narrowing a collection threw the
           shopper off the page entirely instead of undoing the last filter.
           `push: false` is for the popstate re-render below, which must not
           write a new entry for the entry it is restoring. */
        if (push) history.pushState({ nfCollection: true }, '', url);
        else history.replaceState({ nfCollection: true }, '', url);

        /* Re-bind form events on the swapped form (its DOM is new) */
        bindFilterForm();

        /* MEL fix (mobile filtering, Aug 1): the swap replaces [data-grid] and
           [data-load-more], so state living on the OLD nodes must be rebuilt:
           1. Gallery/Catalogue view mode (data-view-mode was on the old grid)
              + toggle visibility for the new card set (Task 5, Aug 12) */
        syncGridViewState();
        /* 2. Infinite-scroll observer was watching the detached wrapper */
        observeLoadMore();

        if (closeOnSuccess) closeDrawer();

        /* Scroll to top of grid (smooth, no jump). Skipped on Back/Forward,
           where the browser restores the scroll position itself. */
        if (scroll) {
          section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.warn('[collection-grid] AJAX nav failed:', err);
          /* Fallback to full page reload */
          window.location.href = url;
        }
      })
      .finally(() => {
        section.removeAttribute('data-loading');
      });
  }

  function buildFilterURL(formEl) {
    const fd = new FormData(formEl);
    const params = new URLSearchParams();
    for (const [k, v] of fd.entries()) {
      if (v) params.append(k, v);
    }
    /* Preserve current sort + gallery view mode */
    const currentUrl = new URL(window.location.href);
    const currentSort = currentUrl.searchParams.get('sort_by');
    if (currentSort) params.set('sort_by', currentSort);
    if (currentUrl.searchParams.get('img') === 'gallery') params.set('img', 'gallery');
    return formEl.action + '?' + params.toString();
  }

  function bindFilterForm() {
    const f = section.querySelector('[data-filter-form]');
    if (!f) return;

    /* Intercept submit — AJAX instead of full reload.
       MEL fix (mobile filtering, Aug 1): in type-fallback mode the checkboxes
       have no name attr, so the old AJAX round-trip sent an EMPTY query and
       re-rendered the unfiltered grid — tapping "Apply filters" on mobile
       erased the selection the user had just made. Fallback mode is client-side
       only: apply + close the drawer, skip the fetch. */
    f.addEventListener('submit', (e) => {
      e.preventDefault();
      const hasServerFilters = f.querySelector('input[name^="filter."]');
      if (!hasServerFilters) {
        applyTypeFilter();
        closeDrawer();
        return;
      }
      applyAjaxNavigation(buildFilterURL(f), { closeOnSuccess: true });
    });

    /* Type-fallback checkboxes are still client-side */
    f.addEventListener('change', (e) => {
      if (e.target.hasAttribute('data-type-filter')) applyTypeFilter();
    });

    /* Price inputs: Enter submits */
    f.querySelectorAll('.cl-filter-price__input input').forEach((inp) => {
      inp.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyAjaxNavigation(buildFilterURL(f));
        }
      });
    });
  }

  /* Intercept chip clicks (each chip is an <a> with the new URL) — go AJAX.
     Same treatment for the drawer's "Clear all" and the empty-state's
     "Clear filters" ([data-filter-clear]), which were plain links: they full-
     reloaded the page and reset the sort and the Gallery mode with it. */
  section.addEventListener('click', (e) => {
    const chip = e.target.closest('.cl-grid__chip');
    if (chip && chip.href) {
      e.preventDefault();
      applyAjaxNavigation(withViewParams(chip.href));
      return;
    }
    const clearLink = e.target.closest('[data-filter-clear]');
    if (clearLink && clearLink.href) {
      e.preventDefault();
      applyAjaxNavigation(withViewParams(clearLink.href), { closeOnSuccess: true });
    }
  });

  /* Back / Forward: re-render from the URL the browser just restored. Without
     this the pushed entries above would change the address bar and nothing
     else. Guarded on the pathname so a real navigation away from the
     collection still goes through the browser. */
  window.addEventListener('popstate', () => {
    if (window.location.pathname !== collectionPath) return;
    applyAjaxNavigation(window.location.href, { push: false, scroll: false });
  });

  bindFilterForm();

  /* Sort: AJAX instead of full reload */
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      applyAjaxNavigation(url.toString());
    });
  }

  /* ════════════════════════════════════════
     CLIENT-SIDE TYPE FILTER (fallback)
     ════════════════════════════════════════ */
  function applyTypeFilter() {
    const checks = section.querySelectorAll('[data-type-filter]:checked');
    const items = section.querySelectorAll('[data-product-type]');
    if (checks.length === 0) {
      items.forEach((i) => { i.hidden = false; });
      return;
    }
    const allowed = new Set(Array.from(checks).map((c) => c.value));
    items.forEach((i) => { i.hidden = !allowed.has(i.dataset.productType); });
  }

  /* ════════════════════════════════════════
     INFINITE SCROLL / LOAD MORE
     MEL fix (mobile filtering, Aug 1): this block used to capture the grid,
     button and spinner nodes ONCE at init. After any AJAX filter/sort the swap
     replaces those nodes, so "load more" appended products to a DETACHED grid
     (nothing visibly happened) and the auto-scroll observer watched a dead
     wrapper. Everything now queries live nodes + uses delegated clicks, and
     the observer is re-attached after every swap (observeLoadMore).
     ════════════════════════════════════════ */
  let loading = false;
  let abortCtrl = null;

  function loadMore() {
    const loadMoreBtn = section.querySelector('[data-load-more-btn]');
    const loadSpinner = section.querySelector('[data-load-spinner]');
    const liveGrid = section.querySelector('[data-grid]');
    if (loading || !loadMoreBtn || !liveGrid) return;
    const url = loadMoreBtn.href;
    if (!url) return;

    loading = true;
    loadMoreBtn.hidden = true;
    if (loadSpinner) loadSpinner.hidden = false;

    abortCtrl?.abort();
    abortCtrl = new AbortController();

    fetch(url, { signal: abortCtrl.signal })
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('[data-collection-grid] [data-grid] .cl-grid__item');
        /* Soft landing (Task 8, Aug 12): appended cards start at opacity 0 /
           6px down ([data-appear] CSS) and release on the next frame with a
           35ms stagger. Reduced-motion users get the instant append (CSS). */
        const appended = [];
        newItems.forEach((item) => {
          item.setAttribute('data-appear', '');
          liveGrid.appendChild(document.adoptNode(item));
          appended.push(item);
        });
        requestAnimationFrame(() => requestAnimationFrame(() => {
          appended.forEach((item, i) => {
            const card = item.querySelector('.nf-card');
            if (card) card.style.transitionDelay = (i * 35) + 'ms';
            item.removeAttribute('data-appear');
          });
          /* Clear the stagger delay once landed so hover transitions stay snappy */
          setTimeout(() => {
            appended.forEach((item) => {
              const card = item.querySelector('.nf-card');
              if (card) card.style.transitionDelay = '';
            });
          }, appended.length * 35 + 400);
        }));

        /* Appended cards in gallery mode: their hidden catalogue twin is fine,
           but their gallery image is the visible one and still lazy — force it
           so load-more doesn't append blank tiles (same trap as the toggle). */
        if (liveGrid.dataset.viewMode === 'gallery') forceLoadGalleryImages();
        /* New cards may (re)introduce gallery images — re-check the toggle */
        updateViewToggleVisibility();

        /* Appended items must respect an active client-side type filter —
           without this, "load more" (auto-fired on mobile scroll) dumped
           unfiltered products into a filtered grid. */
        applyTypeFilter();

        /* Appended page-2 cards can themselves be discounted in this market;
           they arrive at the bottom in collection order, so the band has to be
           re-sorted and re-drawn around the larger set. */
        if (window.NanoleafSaleBand) window.NanoleafSaleBand.paint();
    if (window.NanoleafMarketOrder) window.NanoleafMarketOrder.apply();
    if (window.NanoleafPriceSort) window.NanoleafPriceSort.apply();

        const nextBtn = doc.querySelector('[data-collection-grid] [data-load-more-btn]');
        if (nextBtn) {
          loadMoreBtn.href = nextBtn.href;
          loadMoreBtn.hidden = false;
        } else {
          /* Last page. Drop the wrapper out of the DOM rather than only
             hiding it: `hidden` alone is one stray `display` rule away from
             leaving a live button whose href still points at this page, which
             is what let repeated clicks append the same products over and
             over. Removing it makes the end state unclickable by construction. */
          const wrap = section.querySelector('[data-load-more]');
          if (wrap) {
            wrap.hidden = true;
            wrap.remove();
          }
          loadMoreObserver.disconnect();
        }
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.warn('[collection-grid] load more failed:', err);
          loadMoreBtn.hidden = false;
        }
      })
      .finally(() => {
        loading = false;
        const spinner = section.querySelector('[data-load-spinner]');
        if (spinner) spinner.hidden = true;
      });
  }

  /* Delegated — survives AJAX swaps of [data-load-more] */
  section.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-load-more-btn]');
    if (!btn || !section.contains(btn)) return;
    e.preventDefault();
    loadMore();
  });

  const loadMoreObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const btn = section.querySelector('[data-load-more-btn]');
      if (entry.isIntersecting && btn && !btn.hidden) loadMore();
    });
  }, { rootMargin: '400px' });

  function observeLoadMore() {
    loadMoreObserver.disconnect();
    const wrap = section.querySelector('[data-load-more]');
    if (wrap) loadMoreObserver.observe(wrap);
  }
  observeLoadMore();

  /* ════════════════════════════════════════
     STICKY SIDEBAR BOUND TO PRODUCTS SECTION
     (CSS handles `position: sticky` with `top:`.
      JS enforces the BOTTOM bound — when the
      product grid is scrolled past, sidebar
      releases naturally because parent column
      ends.)
     ════════════════════════════════════════ */
  /* `position: sticky` is naturally bounded by the grid item's height.
     Since the sidebar lives in a grid cell that ends where the products
     end, it auto-unsticks at the section boundary. No extra JS needed. */

  /* ════════════════════════════════════════
     STICKY TOOLBAR — elevated state (Aug 12, offset reworked Aug 13)
     A 1px sentinel above .cl-grid__header leaves the observed zone exactly
     when the bar pins (zone top = the bar's sticky offset, hence the
     rootMargin), toggling .is-stuck for the white surface + shadow.
     The offset is --nf-header-offset — the site header pins at every
     viewport now, so the old runtime is-the-header-pinned probe (scroll
     listener + rect check) is gone: one source of truth, maintained by
     sections/header.liquid, delivered here via the CSS var (which also
     drives the bar's `top` in CSS) and the `nf:header-offset` event.
     ════════════════════════════════════════ */
  (function initStickyToolbar() {
    var header = section.querySelector('.cl-grid__header');
    if (!header || !('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;visibility:hidden;';
    header.parentNode.insertBefore(sentinel, header);
    var observer = null, lastOffset = -1;
    function build(offset) {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function(entries) {
        header.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { threshold: 0, rootMargin: '-' + (offset + 1) + 'px 0px 0px 0px' });
      observer.observe(sentinel);
    }
    function measure() {
      var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nf-header-offset')) || 0;
      if (offset !== lastOffset) {
        lastOffset = offset;
        build(offset);
      }
    }
    measure();
    window.addEventListener('nf:header-offset', measure);
    window.addEventListener('resize', measure, { passive: true });
  })();

  /* ════════════════════════════════════════
     MEL-1015 — Gallery vs Catalogue toggle
     ════════════════════════════════════════ */
  (function initViewToggle() {
    const toggle = section.querySelector('[data-view-toggle]');
    if (!toggle || !section.querySelector('[data-grid]')) return;

    const pills = toggle.querySelectorAll('[data-view-pill]');

    /* URL PARAM IS `img`, NOT `view` (Aug 12): `?view=<suffix>` is Shopify's
       RESERVED template-override param — a full page load with ?view=gallery
       renders templates/collection.gallery.* instead of the assigned template.
       The live theme still carries a STALE collection.gallery.json (the
       pre-redesign page: 6-per-page grid, legacy filter drawer), so the old
       param turned every Gallery-mode reload/share into a time machine.
       `img=gallery` is inert to Shopify. The legacy `view=gallery` is still
       READ (it only reaches this code once the stale template is gone) and is
       migrated to `img=gallery` in the URL immediately. */
    const initUrl = new URL(window.location.href);
    const initial = (initUrl.searchParams.get('img') === 'gallery' || initUrl.searchParams.get('view') === 'gallery') ? 'gallery' : 'catalogue';
    if (initUrl.searchParams.get('view') === 'gallery') {
      initUrl.searchParams.delete('view');
      initUrl.searchParams.set('img', 'gallery');
      history.replaceState({}, '', initUrl.toString());
    }
    applyView(initial, false);

    pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        applyView(pill.dataset.viewPill, true);
      });
    });

    function currentViewIs(view) {
      const active = section.querySelector('[data-view-pill].cl-grid__view-pill--active');
      return active && active.dataset.viewPill === view;
    }

    function applyView(view, updateUrl) {
      /* Pills flip immediately (existing 180ms pill transition) */
      pills.forEach((p) => {
        const active = p.dataset.viewPill === view;
        p.classList.toggle('cl-grid__view-pill--active', active);
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.delete('view'); /* never re-emit the reserved param */
        if (view === 'gallery') url.searchParams.set('img', 'gallery');
        else url.searchParams.delete('img');
        history.replaceState({}, '', url.toString());
      }

      /* Query live — the grid node is replaced on every AJAX filter/sort */
      const liveGrid = section.querySelector('[data-grid]');
      if (!liveGrid) return;

      if (view === 'gallery') {
        /* Task 6 sequencing: promote lazy gallery imgs to eager, stack them
           into the cross-fade layer (data-gallery-ready), DECODE, and only
           then flip data-view-mode so the fade shows a painted image. The
           decode wait is capped at 400ms — a slow network degrades to the
           old behaviour, never a stall. Reduced-motion gets an instant swap
           via the CSS media query. */
        forceLoadGalleryImages();
        liveGrid.setAttribute('data-gallery-ready', '');
        const imgs = Array.prototype.slice.call(liveGrid.querySelectorAll('.nf-card__img--gallery'), 0, 12);
        const decodes = imgs.map((img) => (typeof img.decode === 'function' ? img.decode().catch(() => {}) : Promise.resolve()));
        Promise.race([
          Promise.all(decodes),
          new Promise((r) => setTimeout(r, 400))
        ]).then(() => {
          requestAnimationFrame(() => requestAnimationFrame(() => {
            /* Guard against a rapid toggle back while decoding */
            if (!currentViewIs('gallery')) return;
            const g = section.querySelector('[data-grid]');
            if (g) g.dataset.viewMode = 'gallery';
          }));
        });
      } else {
        liveGrid.dataset.viewMode = view;
      }
    }
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["market-suggestion"]) return;
  try {
    
(function () {
  if (window.__mpInit) return; window.__mpInit = true;

  var root = document.querySelector('[data-mp]');
  if (!root) return;

  var form = root.querySelector('form');
  var countryInput = root.querySelector('[data-mp-country-input]');
  var localeInput = root.querySelector('[data-mp-locale-input]');
  var marketsEl = root.querySelector('[data-mp-markets]');
  var langsEl = root.querySelector('[data-mp-current-languages]');
  var langSelectWrap = root.querySelector('[data-mp-lang-select-wrap]');
  var langSelect = root.querySelector('[data-mp-lang-select]');
  var countryHeading = root.querySelector('[data-mp-heading-template]');
  var langHeading = root.querySelector('[data-mp-lang-heading-template]');
  var continueTemplateEl = root.querySelector('[data-mp-continue-template]');
  var langCtaTemplateEl = root.querySelector('[data-mp-lang-cta-template]');

  var markets = {};
  var currentLanguages = [];
  try { markets = JSON.parse(marketsEl.textContent || '{}'); } catch (e) {}
  try { currentLanguages = JSON.parse(langsEl.textContent || '[]'); } catch (e) {}

  var currentCountry = (root.dataset.currentCountry || '').toUpperCase();
  var currentLang = (root.dataset.currentLang || '').toLowerCase();
  var designMode = root.dataset.designMode === 'true';
  var dismissDays = parseInt(root.dataset.dismissDays, 10) || 30;
  var STORAGE_KEY = 'nf_mp_dismissed_until';

  var headingTemplate = (countryHeading && countryHeading.textContent) || '';
  var continueTemplate = (continueTemplateEl && continueTemplateEl.textContent) || '';
  var langHeadingTemplate = (langHeading && langHeading.textContent) || '';
  var langCtaTemplate = (langCtaTemplateEl && langCtaTemplateEl.textContent) || '';

  // ── Built-in copy for the shop's published languages. The section
  // settings stay the source of truth for English; other languages come
  // from this map so the suggestion reads in the VISITOR'S language, not
  // the page's. Mode A uses the browser language, Mode B the offered one.
  var I18N = {
    en: { heading: headingTemplate, cta: continueTemplate, langHeading: langHeadingTemplate, langCta: langCtaTemplate, dismiss: 'Dismiss' },
    fr: { heading: 'Il semble que vous visitiez depuis {country}.', cta: 'Voir la boutique {country}', langHeading: 'Continuer en {language} ?', langCta: 'Continuer en {language}', dismiss: 'Fermer' },
    de: { heading: 'Es sieht so aus, als würden Sie aus {country} einkaufen.', cta: 'Zum Nanoleaf Shop {country}', langHeading: 'Auf {language} fortfahren?', langCta: 'Auf {language} fortfahren', dismiss: 'Schließen' },
    es: { heading: 'Parece que estás comprando desde {country}.', cta: 'Comprar en Nanoleaf {country}', langHeading: '¿Continuar en {language}?', langCta: 'Continuar en {language}', dismiss: 'Cerrar' },
    it: { heading: 'Sembra che tu stia visitando da {country}.', cta: 'Vai allo shop Nanoleaf {country}', langHeading: 'Continuare in {language}?', langCta: 'Continua in {language}', dismiss: 'Chiudi' },
    ja: { heading: '{country}からアクセスしているようです。', cta: '{country}のストアへ', langHeading: '{language}で続けますか？', langCta: '{language}で続ける', dismiss: '閉じる' },
    ko: { heading: '{country}에서 접속하신 것 같습니다.', cta: '{country} 스토어로 이동', langHeading: '{language}로 계속하시겠습니까?', langCta: '{language}로 계속', dismiss: '닫기' },
    'zh-tw': { heading: '您似乎正從{country}瀏覽。', cta: '前往{country}商店', langHeading: '以{language}繼續？', langCta: '以{language}繼續', dismiss: '關閉' }
  };

  // Browser UI language for the banner copy itself (independent from the
  // market's available languages — a German visitor on the US site still
  // reads the suggestion in German).
  function resolveUiLang() {
    var raw = (navigator.language || (navigator.languages && navigator.languages[0]) || 'en').toLowerCase();
    if (I18N[raw]) return raw;
    var base = raw.split('-')[0];
    if (base === 'zh') return 'zh-tw';
    return I18N[base] ? base : 'en';
  }
  var uiLang = resolveUiLang();

  function strings(lang) {
    return I18N[(lang || '').toLowerCase()] || I18N[uiLang] || I18N.en;
  }

  // Localized country name via the native Intl API, market name as fallback
  function countryName(code, lang, fallback) {
    try {
      var dn = new Intl.DisplayNames([lang, 'en'], { type: 'region' });
      return dn.of(code) || fallback;
    } catch (e) { return fallback; }
  }

  // Self-hosted flags (theme assets) — data-flag-base carries the asset URL
  // of flag-us.png; swapping the country code keeps the CDN version query.
  function flagUrl(code) {
    var base = root.dataset.flagBase || '';
    if (base) return base.replace('flag-us', 'flag-' + String(code).toLowerCase());
    return '';
  }

  var dismissBtn = root.querySelector('[data-mp-dismiss]');
  if (dismissBtn) dismissBtn.setAttribute('aria-label', strings(uiLang).dismiss);

  // ── Push body content down by the banner's height when visible ──
  function pushBody(visible) {
    var h = visible ? root.offsetHeight : 0;
    /* --mp-offset write removed: nothing consumed it, and a custom-property
       write on the root invalidates style for the entire document */
    document.body.style.paddingTop = visible ? h + 'px' : '';
  }

  function tokenize(template, replacements) {
    var out = template || '';
    Object.keys(replacements || {}).forEach(function(k) {
      out = out.replace(new RegExp('\\{' + k + '\\}', 'g'), replacements[k]);
    });
    return out;
  }

  function setMode(mode) {
    // mode: 'country' or 'language'
    if (mode === 'language') {
      countryHeading.hidden = true;
      langHeading.hidden = false;
      langSelectWrap.hidden = false;
      continueTemplateEl.hidden = true;
      langCtaTemplateEl.hidden = false;
    } else {
      countryHeading.hidden = false;
      langHeading.hidden = true;
      langSelectWrap.hidden = true;
      continueTemplateEl.hidden = false;
      langCtaTemplateEl.hidden = true;
    }
  }

  function fillModeA(countryCode, market) {
    countryInput.value = countryCode;
    if (localeInput) {
      /* Keep the current language only if the TARGET market publishes it —
         otherwise omit locale_code entirely (disabled input is not posted)
         and let Shopify land on the target market's default language root. */
      var targetLangs = market.languages || [];
      var keepLang = targetLangs.indexOf(currentLang) !== -1;
      localeInput.disabled = !keepLang;
      localeInput.value = keepLang ? currentLang : '';
    }
    var s = strings(uiLang);
    var cName = countryName(countryCode, uiLang, market.name);
    countryHeading.textContent = tokenize(s.heading, { country: cName });
    continueTemplateEl.textContent = tokenize(s.cta, { country: cName });
    var flagImg = root.querySelector('[data-mp-flag]');
    flagImg.src = flagUrl(market.flag);
    flagImg.alt = cName + ' flag';
    setMode('country');
  }

  function fillModeB(detectedLang) {
    // Keep current country; only switch language
    countryInput.value = currentCountry;
    if (localeInput) localeInput.disabled = false;

    // Build the language dropdown
    langSelect.innerHTML = '';
    currentLanguages.forEach(function(lang) {
      var opt = document.createElement('option');
      opt.value = lang.code;
      opt.textContent = lang.endonym || lang.name || lang.code.toUpperCase();
      if (lang.code === detectedLang) opt.selected = true;
      langSelect.appendChild(opt);
    });

    // Set the initial form locale + heading + CTA label — the copy renders
    // in the OFFERED language ("Continuer en français ?" reads in French)
    var initialLang = detectedLang;
    var initialLangObj = findLang(initialLang) || findLang(currentLanguages[0] && currentLanguages[0].code);
    var langLabel = (initialLangObj && (initialLangObj.endonym || initialLangObj.name)) || initialLang.toUpperCase();
    var initialCode = (initialLangObj && initialLangObj.code) || initialLang;
    localeInput.value = initialCode;
    var sB = strings(initialCode);
    langHeading.textContent = tokenize(sB.langHeading, { language: langLabel });
    langCtaTemplateEl.textContent = tokenize(sB.langCta, { language: langLabel });

    // Flag still shows current country
    var currentMarket = markets[currentCountry];
    var flagImg = root.querySelector('[data-mp-flag]');
    flagImg.src = flagUrl(currentMarket ? currentMarket.flag : currentCountry);
    flagImg.alt = (currentMarket ? currentMarket.name : currentCountry) + ' flag';

    setMode('language');
  }

  function findLang(code) {
    if (!code) return null;
    code = code.toLowerCase();
    for (var i = 0; i < currentLanguages.length; i++) {
      if (currentLanguages[i].code.toLowerCase() === code) return currentLanguages[i];
    }
    return null;
  }

  function show() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('mp--visible');
      setTimeout(function () { pushBody(true); }, 50);
    });
  }

  function dismiss(persist) {
    root.classList.remove('mp--visible');
    pushBody(false);
    setTimeout(function () {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
    }, 450);
    if (persist) {
      try {
        var until = Date.now() + dismissDays * 86400000;
        localStorage.setItem(STORAGE_KEY, String(until));
      } catch (e) {}
    }
  }

  function isDismissed() {
    try {
      var until = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      return until && Date.now() < until;
    } catch (e) { return false; }
  }

  // Browser preferred language (base only, e.g. 'fr-FR' → 'fr')
  function getBrowserLang() {
    var raw = (navigator.language || (navigator.languages && navigator.languages[0]) || '').toLowerCase();
    if (!raw) return null;
    // Special-case zh-TW / zh-CN / pt-BR etc — Shopify locales sometimes use the full code
    var byFull = findLang(raw);
    if (byFull) return byFull.code;
    var base = raw.split('-')[0];
    var byBase = findLang(base);
    if (byBase) return byBase.code;
    return null;
  }

  // Update CTA label / form locale when the user picks a different language
  // in the dropdown — the copy follows the picked language
  if (langSelect) {
    langSelect.addEventListener('change', function() {
      var picked = langSelect.value;
      var langObj = findLang(picked);
      var label = (langObj && (langObj.endonym || langObj.name)) || picked.toUpperCase();
      localeInput.value = picked;
      var sPick = strings(picked);
      langHeading.textContent = tokenize(sPick.langHeading, { language: label });
      langCtaTemplateEl.textContent = tokenize(sPick.langCta, { language: label });
    });
  }

  // ── Theme editor: only show when this section is actively selected ──
  if (designMode) {
    var section = root.closest('.shopify-section');
    if (!section) return;

    function showEditorPreview() {
      // Prefer Mode B preview when multiple languages exist for the current country
      if (currentLanguages.length > 1) {
        // Pick a language different from the current one for the preview
        var preview = null;
        for (var i = 0; i < currentLanguages.length; i++) {
          if (currentLanguages[i].code.toLowerCase() !== currentLang) {
            preview = currentLanguages[i].code;
            break;
          }
        }
        if (!preview) preview = currentLanguages[0].code;
        fillModeB(preview);
        show();
        return;
      }
      // Otherwise preview Mode A with the first non-current market
      var keys = Object.keys(markets).filter(function(k) { return k !== currentCountry; });
      var firstCountry = keys[0] || Object.keys(markets)[0];
      if (firstCountry && markets[firstCountry]) {
        fillModeA(firstCountry, markets[firstCountry]);
        show();
      }
    }
    function hideEditorPreview() {
      root.classList.remove('mp--visible');
      pushBody(false);
      root.hidden = true;
    }

    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId && section.id.indexOf(e.detail.sectionId) !== -1) {
        showEditorPreview();
      }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId && section.id.indexOf(e.detail.sectionId) !== -1) {
        hideEditorPreview();
      }
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId && section.id.indexOf(e.detail.sectionId) !== -1) {
        showEditorPreview();
      }
    });
    return;
  }

  // ── Storefront ──
  if (isDismissed()) return;

  // Use Shopify's edge geolocation (no third-party)
  function detectCountry(cb) {
    var cached = null;
    try { cached = sessionStorage.getItem('nf_mp_geo'); } catch (e) {}
    if (cached) return cb(cached);
    fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        c = c ? c.toUpperCase() : null;
        if (c) { try { sessionStorage.setItem('nf_mp_geo', c); } catch (e) {} }
        cb(c);
      })
      .catch(function () { cb(null); });
  }

  detectCountry(function (detected) {
    // ─ Mode A — country mismatch ─
    if (detected && detected !== currentCountry && markets[detected]) {
      fillModeA(detected, markets[detected]);
      show();
      return;
    }

    // ─ Mode B — language mismatch (right country, browser prefers another available language) ─
    var browserLang = getBrowserLang();
    if (browserLang && browserLang !== currentLang && currentLanguages.length > 1) {
      fillModeB(browserLang);
      show();
      return;
    }

    // Else: no suggestion needed
  });

  // Wire dismiss buttons
  root.querySelector('[data-mp-dismiss]').addEventListener('click', function () { dismiss(true); });
  // Submit button uses native form submission to /localization — no JS handling needed.
  // Just persist the dismiss state on click (so it doesn't show again after redirect)
  root.querySelector('[data-mp-continue]').addEventListener('click', function () { dismiss(true); });

  // Escape closes the banner (same persistence as the dismiss button)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) dismiss(true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-security"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabs = document.querySelectorAll('.security-tab');
    var panels = document.querySelectorAll('.security-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        tabs.forEach(function (t) {
          t.classList.remove('security-tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('security-tab--active');
        this.setAttribute('aria-selected', 'true');

        panels.forEach(function (panel) {
          panel.classList.remove('security-panel--active');
          panel.hidden = true;
        });

        var desc = document.querySelector('[data-security-desc]');
        if (desc) desc.hidden = target !== 'report';

        var activePanel = document.getElementById('tab-' + target);
        if (activePanel) {
          activePanel.classList.add('security-panel--active');
          activePanel.hidden = false;
        }
      });
    });

    // PGP key toggle
    var toggle = document.querySelector('.pgp-key__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        var block = document.getElementById('pgp-key-block');
        if (block) {
          block.hidden = expanded;
        }
        var label = this.querySelector('.pgp-key__toggle-text');
        if (label) {
          label.textContent = expanded ? 'Show PGP Key' : 'Hide PGP Key';
        }
      });
    }

    // PGP key copy
    var copyBtn = document.querySelector('.pgp-key__copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var btn = this;
        var pgpUrl = btn.getAttribute('data-pgp-url');
        var fallback = btn.getAttribute('data-pgp-fallback');

        function doCopy(text) {
          navigator.clipboard.writeText(text).then(function () {
            var orig = btn.textContent;
            btn.textContent = 'Copied!';
            setTimeout(function () {
              btn.textContent = orig;
            }, 2000);
          }).catch(function () {
            btn.textContent = 'Copy failed';
            setTimeout(function () {
              btn.textContent = 'Copy PGP Key';
            }, 2000);
          });
        }

        if (pgpUrl) {
          fetch(pgpUrl)
            .then(function (res) { return res.text(); })
            .then(function (text) { doCopy(text); })
            .catch(function () { doCopy(fallback); });
        } else {
          doCopy(fallback);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-background-video"] && !Shopify.designMode) return;
  try {
    
/* Decorative-video robustness layer.
   ---------------------------------
   The <video> already has autoplay+loop+muted+playsinline, which is the
   standard set Chrome / Safari / Firefox honour for muted background video.
   But some real-world conditions still stop autoplay from kicking in:

   - Aggressive autoplay-block extensions / Chrome privacy settings
   - Page loaded in a background tab (Chrome defers autoplay)
   - Low-power mode on macOS / iOS
   - Data Saver mode

   This script makes the video play in those cases too:
   1. Wait until the video frame is at least 30% in viewport (saves bandwidth).
   2. Try .play(). Most browsers resolve fine.
   3. If .play() rejects (NotAllowedError), the user has autoplay blocked —
      register one-time listeners on scroll/click/touch/keydown that retry
      .play() on the first interaction (counts as a "user gesture").
   4. Once playing, listeners self-clean. */
(() => {
  /* ── Scrub mode ─────────────────────────────────────────────────────
     Apple-style scroll scrubbing: the video's currentTime is mapped to
     the section's progress through the viewport (enters at bottom = 0,
     leaves at top = duration). Replaces the laggy image-sequence hack
     from the old site with one compressed MP4.
     Requirements: keyframe-dense encode (ffmpeg -g 1) for smooth seeks.
     Reduced-motion users get a static poster frame instead. */
  const scrubSections = document.querySelectorAll('.pdp-bg-video[data-playback="scrub"]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  scrubSections.forEach(section => {
    const video = section.querySelector('.pdp-bg-video__video');
    if (!video || reducedMotion) return;

    let duration = 0;
    let targetTime = 0;
    let appliedTime = -1;
    let ticking = false;
    let active = false;

    const applyFrame = () => {
      ticking = false;
      if (!duration) return;
      // Skip micro-seeks — re-seeking every scroll pixel floods the decoder.
      if (Math.abs(targetTime - appliedTime) < 0.033) return;
      appliedTime = targetTime;
      video.currentTime = targetTime;
    };

    const onScroll = () => {
      if (!active || !duration) return;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      targetTime = progress * Math.max(0, duration - 0.05);
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(applyFrame);
      }
    };

    video.addEventListener('loadedmetadata', () => {
      duration = video.duration || 0;
      video.pause();
      onScroll();
    });
    if (video.readyState >= 1) {
      duration = video.duration || 0;
      video.pause();
    }

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => { active = entry.isIntersecting; });
      if (active) onScroll();
    }, { rootMargin: '50% 0px' });
    io.observe(section);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  });

  /* ── Loop mode (default) — autoplay robustness layer ── */
  const videos = document.querySelectorAll('.pdp-bg-video[data-playback="loop"] .pdp-bg-video__video, .pdp-bg-video:not([data-playback]) .pdp-bg-video__video');
  if (!videos.length || !('IntersectionObserver' in window)) return;

  const gestureEvents = ['scroll', 'pointerdown', 'touchstart', 'keydown'];

  const tryPlay = (video) => {
    const p = video.play();
    if (!p || typeof p.then !== 'function') return;
    p.catch(() => {
      // Autoplay blocked. Retry on first user gesture, once.
      const handler = () => {
        video.play().catch(() => {});
        gestureEvents.forEach(ev => window.removeEventListener(ev, handler, { capture: true }));
      };
      gestureEvents.forEach(ev =>
        window.addEventListener(ev, handler, { once: true, capture: true, passive: true })
      );
    });
  };

  /* Track which videos are currently in view so we know whether to
     resume after a forced pause (tab blur, visibilitychange, etc). */
  const inView = new WeakSet();

  /* Belt-and-suspenders loop. The HTML5 `loop` attribute is honoured by
     all modern browsers but a handful of bugs still cause `ended` to
     fire mid-loop on iOS, mid-MSE feeds, and during HLS-to-MP4 fallback.
     Re-seek + play on every `ended` so the video never just stops. */
  const reinforceLoop = (video) => {
    video.addEventListener('ended', () => {
      video.currentTime = 0;
      tryPlay(video);
    });
    /* If the browser pauses the video for an external reason (battery
       saver, focus loss, AirPlay handoff) and the section is still in
       view, resume playback. */
    video.addEventListener('pause', () => {
      // Don't fight a legitimate end-of-stream pause (handled by `ended`).
      if (video.ended) return;
      if (!inView.has(video)) return;
      if (document.visibilityState !== 'visible') return;
      /* Never fight a deliberate pause: reduced-motion preference or the
         ambient-video-pause control (snippets/ambient-video-pause.liquid). */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (video.dataset.userPaused === 'true') return;
      // Microtask delay — gives the browser a tick to finish its pause
      // before we contradict it.
      queueMicrotask(() => tryPlay(video));
    });
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        const v = entry.target;
        if (entry.isIntersecting) {
          inView.add(v);
          tryPlay(v);
        } else {
          inView.delete(v);
          if (!v.paused) v.pause(); // Saves CPU / battery
        }
      });
    },
    { threshold: [0, 0.3], rootMargin: '100px 0px' }
  );

  videos.forEach(v => {
    reinforceLoop(v);
    io.observe(v);
  });

  /* When the tab regains focus, resume any in-view videos that the
     browser quietly paused while the tab was backgrounded. */
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState !== 'visible') return;
    videos.forEach(v => { if (inView.has(v) && v.paused) tryPlay(v); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-bundle-upsell"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* "Shop the bundle" — spinner while the browser navigates to the bundle
     PDP. Navigation is NOT prevented; the class only swaps label for the
     spinner and blocks double-clicks. pageshow (incl. bfcache restores via
     Back) clears the state so the button never comes back stuck. */
  var shopBtns = document.querySelectorAll('[data-bundle-shop]');
  if (shopBtns.length) {
    shopBtns.forEach(function(a) {
      a.addEventListener('click', function() {
        a.classList.add('is-loading');
      });
    });
    window.addEventListener('pageshow', function() {
      shopBtns.forEach(function(a) { a.classList.remove('is-loading'); });
    });
  }

  var btn = document.querySelector('[data-bundle-add]');
  if (!btn) return;
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    var vid = btn.dataset.variantId;
    if (!vid || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    var origHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:spin 0.6s linear infinite"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
    .then(function(r) { if (!r.ok) { return r.json().catch(function() { return {}; }).then(function(err) { throw new Error((err && (err.description || err.message)) || 'Could not add to cart'); }); } return r.json(); })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added';
      document.dispatchEvent(new CustomEvent('cart:updated'));
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.innerHTML = origHTML;
      }, 1200);
    })
    .catch(function() {
      btn.classList.remove('is-adding');
      btn.innerHTML = origHTML;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-stories"] && !Shopify.designMode) return;
  try {
    
// Before/after slider — pointer drag + keyboard, one init per instance.
// Same interaction model as sections/pdp-before-after.liquid.
for (const ba of document.querySelectorAll('[data-tmb-ba]')) {
  const handle = ba.querySelector('[data-tmb-ba-handle]');
  if (!handle) continue;
  const clipLayer = ba.querySelector('.pdp-tmb__ba-before');
  let pos = 50;

  /* Drive children directly (clip-path % + handle transform) instead of a
     parent custom property, which invalidated style for the whole subtree
     and moved the handle via `left` (layout) on every pointer event. */
  handle.style.left = '0';
  const apply = () => {
    const rect = ba.getBoundingClientRect();
    if (clipLayer) clipLayer.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
    handle.style.transform = 'translateX(' + (rect.width * pos / 100) + 'px) translateX(-50%)';
    handle.setAttribute('aria-valuenow', String(Math.round(pos)));
  };
  window.addEventListener('resize', apply, { passive: true });

  const setFromClientX = (clientX) => {
    const rect = ba.getBoundingClientRect();
    if (rect.width === 0) return;
    /* Rising friction at the clamp instead of a hard stop-then-teleport */
    const raw = ((clientX - rect.left) / rect.width) * 100;
    let p;
    if (raw < 4)       p = 4 - Math.pow(4 - raw, 0.6);
    else if (raw > 96) p = 96 + Math.pow(raw - 96, 0.6);
    else               p = raw;
    pos = Math.min(99, Math.max(1, p));
    apply();
  };

  let dragging = false;
  handle.addEventListener('pointerdown', (e) => {
    dragging = true;
    ba.setAttribute('data-dragging', '');
    try { handle.setPointerCapture(e.pointerId); } catch (err) { /* pointer already released */ }
    e.preventDefault();
  });
  handle.addEventListener('pointermove', (e) => {
    if (!dragging) return;
    setFromClientX(e.clientX);
  });
  const stop = () => {
    dragging = false;
    ba.removeAttribute('data-dragging');
  };
  handle.addEventListener('pointerup', stop);
  handle.addEventListener('pointercancel', stop);

  // Tap/click anywhere on the image jumps the divider there.
  ba.addEventListener('pointerdown', (e) => {
    if (e.target.closest('[data-tmb-ba-handle]')) return;
    setFromClientX(e.clientX);
  });

  handle.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
      pos = Math.max(4, pos - 5);
    } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
      pos = Math.min(96, pos + 5);
    } else if (e.key === 'Home') {
      pos = 4;
    } else if (e.key === 'End') {
      pos = 96;
    } else {
      return;
    }
    e.preventDefault();
    apply();
  });

  ba.addEventListener('dragstart', (e) => e.preventDefault());
  apply();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-text-media"] && !Shopify.designMode) return;
  try {
    
  // MEL-1027 — Slider behavior: dot click → scroll-to, scroll → highlight dot.
  if (!customElements.get('pdp-text-media-slider')) {
    customElements.define('pdp-text-media-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = Array.from(this.querySelectorAll('[data-dot-index]'));
        if (!this.track || !this.dots.length) return;

        this.dots.forEach((dot) => {
          dot.addEventListener('click', this.#onDotClick.bind(this));
        });

        if ('IntersectionObserver' in window) {
          this.#observeSlides();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      #onDotClick(event) {
        const index = parseInt(event.currentTarget.dataset.dotIndex, 10);
        const slides = this.track.children;
        const target = slides[index];
        if (!target) return;
        this.track.scrollTo({
          left: target.offsetLeft - this.track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      #observeSlides() {
        const slides = Array.from(this.track.children);
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
                const index = slides.indexOf(entry.target);
                if (index < 0) return;
                this.dots.forEach((dot, i) => {
                  const active = i === index;
                  dot.classList.toggle('pdp-text-media__dot--active', active);
                  dot.setAttribute('aria-selected', active ? 'true' : 'false');
                });
              }
            });
          },
          { root: this.track, threshold: [0.5, 0.75, 1] }
        );
        slides.forEach((s) => this.observer.observe(s));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('.product-recommendations[data-url]');
    if (!section) return;

    var url = section.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations fetch failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshSection = doc.querySelector('.product-recommendations');
        if (freshSection && freshSection.innerHTML.trim().length > 0) {
          section.innerHTML = freshSection.innerHTML;
        }
      })
      .catch(function () {
        /* Silently degrade — section stays empty */
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-bundle"] && !Shopify.designMode) return;
  try {
    
/* ── products-bundle custom elements ──────────────────────── */

if (!customElements.get('lookbook-icon')) {
  class LookbookIcon extends HTMLElement {
    connectedCallback() {
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
        }
      });
    }
  }
  customElements.define('lookbook-icon', LookbookIcon);
}

if (!customElements.get('product-bundle')) {
  class ProductBundle extends HTMLElement {
    connectedCallback() {
      this._select   = this.querySelector('.pb__variant-select');
      this._priceWrap = this.querySelector('[data-price-wrapper]');

      if (this._select) {
        this._select.addEventListener('change', () => this._onVariantChange());
      }

      /* Navigate to product page on row click — skip interactive elements */
      const url = this.dataset.productUrl;
      if (url) {
        this.addEventListener('click', (e) => {
          if (window.Shopify && window.Shopify.designMode) return;
          if (e.target.closest('select, button, input, a, label, [role="button"]')) return;
          window.location.href = url;
        });
      }
    }

    _onVariantChange() {
      const opt        = this._select.options[this._select.selectedIndex];
      const variantId  = opt.value;
      const price      = parseInt(opt.dataset.price, 10) || 0;
      const compare    = parseInt(opt.dataset.comparePrice, 10) || 0;
      const onSale     = compare > price;

      this.dataset.variantId = variantId;

      if (!this._priceWrap) return;

      // Update current price
      const currentEl = this._priceWrap.querySelector('.price__current');
      if (currentEl) currentEl.textContent = this._formatMoney(price);

      // Update on-sale state
      this._priceWrap.classList.toggle('price--on-sale', onSale);

      // Update compare price
      let compareEl = this._priceWrap.querySelector('.price__compare');
      if (onSale) {
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'price__compare';
          compareEl.setAttribute('aria-hidden', 'true');
          this._priceWrap.insertBefore(compareEl, this._priceWrap.firstChild);
        }
        compareEl.textContent = this._formatMoney(compare);
      } else if (compareEl) {
        compareEl.remove();
      }

      // Update save badge
      let badgeEl = this._priceWrap.querySelector('.price__save-badge');
      if (onSale && compare > 0) {
        const pct = Math.round((compare - price) * 100 / compare);
        if (!badgeEl) {
          badgeEl = document.createElement('span');
          badgeEl.className = 'price__save-badge';
          badgeEl.setAttribute('aria-hidden', 'true');
          this._priceWrap.appendChild(badgeEl);
        }
        badgeEl.textContent = 'Save ' + pct + '%';
      } else if (badgeEl) {
        badgeEl.remove();
      }

      // Update data attributes
      this._priceWrap.dataset.price        = price;
      this._priceWrap.dataset.comparePrice = compare;
    }

    _formatMoney(cents) {
      /* Delegate to the one global formatter so this section can't drift from
         the rest of the site. It had its own Intl call defaulting to en-CA/CAD,
         which rendered a different symbol from Liquid on the same page. */
      if (window.NanoleafTheme && window.NanoleafTheme.formatMoney) {
        return window.NanoleafTheme.formatMoney(cents);
      }
      var currency = document.body.getAttribute('data-active-currency')
        || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var locale = document.body.getAttribute('data-locale') || document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(locale, {
          style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
        }).format(cents / 100);
      } catch (e) {
        return new Intl.NumberFormat(locale, {
          style: 'currency', currency: currency, minimumFractionDigits: 2,
        }).format(cents / 100);
      }
    }
  }
  customElements.define('product-bundle', ProductBundle);
}

if (!customElements.get('products-bundle')) {
  class ProductsBundle extends HTMLElement {
    connectedCallback() {
      this._rows      = () => Array.from(this.querySelectorAll('.pb__product-wrap[data-block-id]'));
      this._pins      = () => Array.from(this.querySelectorAll('.pb__pin[data-block-id]'));
      this._addAllBtn = this.querySelector('[data-add-all]');

      // Unified hover — both rows and pins fade others + show arrow
      this.addEventListener('mouseenter', (e) => {
        const row = e.target.closest('.pb__product-wrap[data-block-id]');
        const pin = e.target.closest('.pb__pin[data-block-id]');
        if (row) this._highlight(row.dataset.blockId);
        if (pin) this._highlight(pin.dataset.blockId);
      }, true);

      this.addEventListener('mouseleave', (e) => {
        const row = e.target.closest('.pb__product-wrap[data-block-id]');
        const pin = e.target.closest('.pb__pin[data-block-id]');
        if ((row || pin) && !this.querySelector('.pb__product-wrap[data-block-id]:hover') && !this.querySelector('.pb__pin[data-block-id]:hover')) {
          this._clearActive();
        }
      }, true);

      // Pin click — navigate to matching product page
      this.addEventListener('click', (e) => {
        if (window.Shopify && window.Shopify.designMode) return;
        const pin = e.target.closest('.pb__pin[data-block-id]');
        if (!pin) return;
        const blockId = pin.dataset.blockId;
        const row = this.querySelector(`.pb__product-wrap[data-block-id="${blockId}"]`);
        if (row && row.dataset.productUrl) {
          window.location.href = row.dataset.productUrl;
        }
      });

      if (this._addAllBtn) {
        this._addAllBtn.addEventListener('click', () => this._addAllToCart());
      }

      // Editor-only: drag pins to read their position (values are not saved)
      if (window.Shopify && window.Shopify.designMode) {
        this._initPinEditor();
      }
    }

    _initPinEditor() {
      const pins = Array.from(this.querySelectorAll('.pb__pin[data-slot]'));
      const wrap = this.querySelector('.pb__image-wrap');
      const col  = this.querySelector('.pb__image-col');
      if (!pins.length || !wrap || !col) return;

      // The theme editor reconnects this element repeatedly. Clear any panel
      // left over from a previous run so only one is ever shown.
      this.querySelectorAll('.pb__pin-editor').forEach((el) => el.remove());

      const panel = document.createElement('div');
      panel.className = 'pb__pin-editor';
      panel.innerHTML =
        '<div class="pb__pin-editor-title">Pin positions (editor preview only)</div>' +
        '<div class="pb__pin-editor-hint">Drag a pin on the image, then copy the two numbers into this product\u2019s product_bundle metaobject. Dragging here is not saved.</div>';
      const list = document.createElement('div');
      list.className = 'pb__pin-editor-rows';
      panel.appendChild(list);
      col.appendChild(panel);

      const rows = {};
      pins.forEach((pin) => {
        const slot = pin.dataset.slot;
        const row = document.createElement('div');
        row.className = 'pb__pin-editor-row';
        row.innerHTML =
          '<span class="pb__pin-editor-key">Pin ' + slot + '</span>' +
          '<span class="pb__pin-editor-val" data-slot="' + slot + '"></span>';
        list.appendChild(row);
        rows[slot] = row.querySelector('.pb__pin-editor-val');
        pin.style.cursor = 'move';
        pin.classList.add('pb__pin--editable');
      });

      const update = (pin) => {
        const slot = pin.dataset.slot;
        const t = Math.round(parseFloat(pin.style.top))  || 0;
        const l = Math.round(parseFloat(pin.style.left)) || 0;
        if (rows[slot]) {
          rows[slot].textContent = 'top ' + t + '  ·  left ' + l +
            '   (product_' + slot + '_pin_top / _left)';
        }
      };
      pins.forEach(update);

      let active = null;
      const onMove = (e) => {
        if (!active) return;
        const rect = wrap.getBoundingClientRect();
        let l = ((e.clientX - rect.left) / rect.width)  * 100;
        let t = ((e.clientY - rect.top)  / rect.height) * 100;
        l = Math.min(100, Math.max(0, l));
        t = Math.min(100, Math.max(0, t));
        active.style.left = l + '%';
        active.style.top  = t + '%';
        update(active);
        e.preventDefault();
      };
      const onUp = () => {
        if (active) active.classList.remove('pb__pin--dragging');
        active = null;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
      };
      pins.forEach((pin) => {
        if (pin._pbPinDown) pin.removeEventListener('pointerdown', pin._pbPinDown);
        pin._pbPinDown = (e) => {
          active = pin;
          pin.classList.add('pb__pin--dragging');
          document.addEventListener('pointermove', onMove);
          document.addEventListener('pointerup', onUp);
          e.preventDefault();
          e.stopPropagation();
        };
        pin.addEventListener('pointerdown', pin._pbPinDown);
      });
    }

    _highlight(blockId) {
      this.classList.add('is-hover');
      this._rows().forEach((r) => r.classList.toggle('is-active', r.dataset.blockId === blockId));
      this._pins().forEach((p) => p.classList.toggle('is-active', p.dataset.blockId === blockId));
    }

    _clearActive() {
      this.classList.remove('is-hover');
      this._rows().forEach((r) => r.classList.remove('is-active'));
      this._pins().forEach((p) => p.classList.remove('is-active'));
    }

    _addAllToCart() {
      const rows = this._rows();
      if (!rows.length) return;

      const items = rows.map((row) => {
        const vid = row.dataset.variantId ||
          (row.querySelector('.pb__variant-select') ? row.querySelector('.pb__variant-select').value : null);
        return vid ? { id: parseInt(vid, 10), quantity: 1 } : null;
      }).filter(Boolean);

      if (!items.length) return;

      const btn     = this._addAllBtn;
      const label   = btn.querySelector('.pb__add-all-label');
      const loading = btn.querySelector('.pb__add-all-loading');

      btn.disabled = true;
      btn.classList.add('is-adding');
      if (label)   label.hidden   = true;
      if (loading) loading.hidden = false;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items }),
      })
        .then((res) => { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          /* Short "Added ✓" confirmation on the same green fill, then revert */
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          if (loading) loading.hidden = true;
          if (label) {
            const origLabel = label.textContent;
            label.textContent = 'Added ✓';
            label.hidden = false;
            setTimeout(() => {
              btn.classList.remove('is-added');
              btn.disabled = false;
              label.textContent = origLabel;
            }, 1200);
          } else {
            btn.classList.remove('is-added');
            btn.disabled = false;
          }
        })
        .catch((err) => {
          console.error('[products-bundle] cart/add error:', err);
          btn.classList.remove('is-adding');
          btn.disabled = false;
          if (label)   label.hidden   = false;
          if (loading) loading.hidden = true;
        });
    }
  }
  customElements.define('products-bundle', ProductsBundle);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psu-calculator"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Power consumption constants ── */
  var PRODUCTS = {
    shapes: {
      panels: {
        'shapes-hex':  { label: 'Hexagons',       watts: 2 },
        'shapes-tri':  { label: 'Triangles',      watts: 1.5 },
        'shapes-mini': { label: 'Mini Triangles',  watts: 0.54 }
      },
      fixedWatts: 0,
      psu: { '42': 44 }
    },
    elements: {
      panels: {
        'elements-hex': { label: 'Elements Hexagons', watts: 2 }
      },
      fixedWatts: 0,
      psu: { '42': 44 }
    },
    lines: {
      panels: {
        'lines-bars':        { label: 'Line Bars',               watts: 2.1 },
        'lines-connectors':  { label: 'Mounting Connectors (60°)', watts: 0.24 },
        'lines-controllers': { label: 'Controllers',             watts: 0.17 }
      },
      fixedWatts: 2,   /* 1 processor */
      psu: { '42': 44, '75': 73 }
    },
    blocks: {
      panels: {
        'blocks-squares':  { label: 'Squares',          watts: 3 },
        'blocks-pegboard': { label: 'Light Pegboard',   watts: 3 },
        'blocks-textured': { label: 'Textured Squares', watts: 3 },
        'blocks-small':    { label: 'Small Squares',    watts: 0.8 }
      },
      fixedWatts: 1.5,  /* 1 controller */
      psu: { '42': 44, '75': 73 }
    },
    canvas: {
      panels: {
        'canvas-squares': { label: 'Canvas Squares', watts: 1 }
      },
      fixedWatts: 0,
      psu: { '75': 73 }   /* 75W PSU only; ~1W per square, up to 73 panels */
    },
    expo: {
      panels: {
        'expo-cases': { label: 'Display Cases', watts: 5 }
      },
      fixedWatts: 0,
      psu: { '75': 73 }   /* 75W PSU only; ~5W per case, up to 14 cases */
    }
  };

  /* Map product+wattage to the CMS card data-attribute key */
  var CARD_MAP = {
    'shapes-42':   'shapes_42w_product',
    'elements-42': 'elements_42w_product',
    'lines-42':    'lines_42w_product',
    'lines-75':    'lines_75w_product',
    'blocks-42':   'blocks_42w_product',
    'blocks-75':   'blocks_75w_product',
    'canvas-75':   'canvas_75w_product',
    'expo-75':     'expo_75w_product'
  };

  /* ── DOM refs ── */
  var productSelect   = document.querySelector('[data-psu-product]');
  var wattageToggle   = document.querySelector('[data-psu-wattage-toggle]');
  var btn75w          = document.querySelector('[data-psu-75w-btn]');
  var calcBtn         = document.querySelector('[data-psu-calculate]');
  var errorEl         = document.querySelector('[data-psu-error]');
  var resultsWrap     = document.querySelector('[data-psu-results]');
  var placeholderEl   = document.querySelector('[data-psu-placeholder]');
  var countEl         = document.querySelector('[data-psu-count]');
  var unitEl          = document.querySelector('[data-psu-unit]');
  var allInputGroups  = document.querySelectorAll('[data-inputs]');
  var allCards        = document.querySelectorAll('[data-psu-card]');
  var fallbackCard    = document.querySelector('[data-psu-card-fallback]');
  var wattBtns        = wattageToggle ? wattageToggle.querySelectorAll('.psu-calc__toggle-btn') : [];

  var btn42w          = document.querySelector('[data-psu-42w-btn]');

  var currentProduct  = 'shapes';
  var currentWattage  = '42';

  /* ── Helpers ── */
  function showInputGroup(product) {
    allInputGroups.forEach(function (g) {
      g.style.display = g.getAttribute('data-inputs') === product ? '' : 'none';
    });
  }

  function update75wVisibility(product) {
    var has42 = PRODUCTS[product].psu['42'] !== undefined;
    var has75 = PRODUCTS[product].psu['75'] !== undefined;
    if (btn42w) btn42w.style.display = has42 ? '' : 'none';
    if (btn75w) btn75w.style.display = has75 ? '' : 'none';
    /* Auto-select the only available wattage when switching products */
    if (!has42 && has75) {
      currentWattage = '75';
      setActiveWattage('75');
    } else if (!has75 && currentWattage === '75') {
      currentWattage = '42';
      setActiveWattage('42');
    }
  }

  function setActiveWattage(w) {
    wattBtns.forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-wattage') === w);
    });
  }

  function showCard(product, wattage) {
    var key = product + '-' + wattage;
    var cardKey = CARD_MAP[key];
    var shown = false;
    allCards.forEach(function (c) {
      var match = c.getAttribute('data-psu-card') === cardKey;
      c.style.display = match ? '' : 'none';
      if (match) shown = true;
    });
    if (fallbackCard) {
      fallbackCard.style.display = shown ? 'none' : '';
    }
  }

  function hideAllCards() {
    allCards.forEach(function (c) { c.style.display = 'none'; });
    if (fallbackCard) fallbackCard.style.display = 'none';
  }

  function clearInputs() {
    allInputGroups.forEach(function (g) {
      var inputs = g.querySelectorAll('input');
      inputs.forEach(function (inp) { inp.value = ''; });
    });
  }

  function showPlaceholder() {
    if (placeholderEl) placeholderEl.style.display = '';
    resultsWrap.style.display = 'none';
  }

  function hidePlaceholder() {
    if (placeholderEl) placeholderEl.style.display = 'none';
  }

  /* ── Event: product change ── */
  if (productSelect) {
    productSelect.addEventListener('change', function () {
      currentProduct = this.value;
      showInputGroup(currentProduct);
      update75wVisibility(currentProduct);
      clearInputs();
      showPlaceholder();
      errorEl.style.display = 'none';
      hideAllCards();
    });
  }

  /* ── Event: wattage toggle ── */
  wattBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      currentWattage = this.getAttribute('data-wattage');
      setActiveWattage(currentWattage);
    });
  });

  /* ── Event: calculate ── */
  if (calcBtn) {
    calcBtn.addEventListener('click', function () {
      var config = PRODUCTS[currentProduct];
      if (!config) return;

      var totalWatts = config.fixedWatts;
      var hasAnyInput = false;
      var activeGroup = document.querySelector('[data-inputs="' + currentProduct + '"]');

      if (activeGroup) {
        var inputs = activeGroup.querySelectorAll('input[type="number"]');
        inputs.forEach(function (inp) {
          var val = parseInt(inp.value, 10);
          if (val > 0) {
            hasAnyInput = true;
            var panelKey = inp.getAttribute('data-panel');
            var panelConfig = config.panels[panelKey];
            if (panelConfig) {
              totalWatts += val * panelConfig.watts;
            }
          }
        });
      }

      if (!hasAnyInput) {
        errorEl.style.display = '';
        showPlaceholder();
        hideAllCards();
        return;
      }

      errorEl.style.display = 'none';

      var capacity = config.psu[currentWattage];
      if (!capacity) {
        /* Fallback to 42W if wattage somehow invalid */
        capacity = config.psu['42'];
        currentWattage = '42';
        setActiveWattage('42');
      }

      var psuCount = Math.ceil(totalWatts / capacity);
      if (psuCount < 1) psuCount = 1;

      countEl.textContent = psuCount;
      unitEl.textContent = psuCount === 1 ? 'PSU' : 'PSUs';
      hidePlaceholder();
      resultsWrap.style.display = '';
      showCard(currentProduct, currentWattage);
    });
  }

  /* Init */
  showInputGroup(currentProduct);
  update75wVisibility(currentProduct);

  /* ── Add to Cart via fetch (no page redirect) ── */
  document.querySelectorAll('[data-psu-add-to-cart]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var vid = btn.dataset.psuAddToCart;
      if (!vid || btn.classList.contains('is-adding')) return;
      btn.classList.add('is-adding');
      var origText = btn.textContent;
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:nfSpin 0.7s linear infinite;vertical-align:-2px"><path d="M12 2a10 10 0 1 0 10 10"/></svg>';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
      })
      .then(function(r) { if (!r.ok) { return r.json().catch(function() { return {}; }).then(function(err) { throw new Error((err && (err.description || err.message)) || 'Could not add to cart'); }); } return r.json(); })
      .then(function() {
        btn.classList.remove('is-adding');
        btn.classList.add('is-added');
        btn.textContent = 'Added \u2713';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.textContent = origText;
        }, 1200);
      })
      .catch(function() {
        btn.classList.remove('is-adding');
        btn.textContent = origText;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  const banner = document.querySelector('sale-banner');
  if (!banner) return;

  const sectionId = banner.dataset.sectionId;
  const storageKey = 'sale-banner-dismissed-' + sectionId;

  /* ── Dismiss logic ── */
  if (sessionStorage.getItem(storageKey)) {
    banner.hidden = true;
    return;
  }

  document.documentElement.classList.add('has-sale-banner');
  requestAnimationFrame(function () { banner.classList.add('is-open'); });

  banner.querySelector('[data-sale-dismiss]').addEventListener('click', function () {
    banner.classList.remove('is-open');
    banner.classList.add('sale-banner--closing');
    banner.addEventListener('transitionend', function () {
      banner.hidden = true;
      document.documentElement.classList.remove('has-sale-banner');
    }, { once: true });
    sessionStorage.setItem(storageKey, '1');
  });

  /* ── Countdown timer ── */
  const endStr = banner.dataset.endDate;
  if (!endStr) return;

  /* MEL-1234: end time from Liquid (store timezone), so every visitor counts
     down to the same moment; the raw string would be read in their own timezone. */
  const endTs = parseInt(banner.dataset.endTs, 10);
  const endDate = endTs > 0 ? new Date(endTs * 1000) : new Date(endStr);
  if (isNaN(endDate.getTime())) return;

  const lang = document.documentElement.lang || 'en';
  if (!/^en\b/i.test(lang) && window.Intl && Intl.NumberFormat) {
    banner.querySelectorAll('[data-unit]').forEach(function (u) {
      try {
        new Intl.NumberFormat(lang, { style: 'unit', unit: u.dataset.unit, unitDisplay: u.dataset.unit === 'day' ? 'long' : 'short' })
          .formatToParts(2).forEach(function (p) { if (p.type === 'unit') u.textContent = p.value; });
      } catch (e) {}
    });
  }

  const daysEl    = banner.querySelector('[data-days]');
  const hoursEl   = banner.querySelector('[data-hours]');
  const minutesEl = banner.querySelector('[data-minutes]');
  const secondsEl = banner.querySelector('[data-seconds]');

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    const now  = Date.now();
    const diff = endDate.getTime() - now;

    if (diff <= 0) {
      daysEl.textContent    = '00';
      hoursEl.textContent   = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';

      const headline = banner.querySelector('.sale-banner__headline');
      if (headline) headline.textContent = 'Sale Ended';

      const cta = banner.querySelector('.sale-banner__cta');
      if (cta) cta.style.display = 'none';

      return;
    }

    const totalSec = Math.floor(diff / 1000);
    const d = Math.floor(totalSec / 86400);
    const h = Math.floor((totalSec % 86400) / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;

    daysEl.textContent    = pad(d);
    hoursEl.textContent   = pad(h);
    minutesEl.textContent = pad(m);
    secondsEl.textContent = pad(s);

    requestAnimationFrame(function () {
      setTimeout(tick, 1000 - (Date.now() % 1000));
    });
  }

  tick();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-card"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-story-card]').forEach(function (root) {
    /* ── Floating callouts: tap a dot to reveal its tag, tap again to hide ── */
    var callouts = root.querySelectorAll('.story-card__callout');
    function closeCallouts() {
      callouts.forEach(function (c) {
        c.classList.remove('is-open');
        var d = c.querySelector('.story-card__callout-dot');
        if (d) d.setAttribute('aria-expanded', 'false');
      });
    }
    callouts.forEach(function (callout) {
      var dot = callout.querySelector('.story-card__callout-dot');
      if (!dot) return;
      dot.addEventListener('click', function () {
        var willOpen = !callout.classList.contains('is-open');
        closeCallouts();
        if (willOpen) {
          callout.classList.add('is-open');
          dot.setAttribute('aria-expanded', 'true');
        }
      });
    });
    /* Tapping anywhere outside an open callout closes it (but never blocks the pill link) */
    if (callouts.length) {
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.story-card__callout')) return;
        closeCallouts();
      });
    }

    /* ── Product pins + cards ── */
    var pins = root.querySelectorAll('.story-card__pin');
    var cards = root.querySelectorAll('[data-product-card]');
    if (pins.length && cards.length) {
      var activate = function (idx) {
        pins.forEach(function (p, i) { p.classList.toggle('story-card__pin--active', i === idx); });
        cards.forEach(function (c, i) {
          c.classList.toggle('story-card__product-card--active', i === idx);
          if (i === idx) c.removeAttribute('aria-hidden');
          else c.setAttribute('aria-hidden', 'true');
        });
      };
      pins.forEach(function (p, i) {
        p.addEventListener('click', function () { activate(i); });
      });
    }

    /* ── Add-to-cart: optimistic submit via fetch, falls back to native form post ── */
    root.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return; /* legacy fallback to native post */
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        var originalHTML = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('is-adding');
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="animation:nfSpin 0.7s linear infinite"><path d="M12 2a10 10 0 1 0 10 10"/></svg>';
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams(new FormData(form)).toString()
        }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
          .then(function () {
            btn.classList.remove('is-adding');
            btn.classList.add('is-added');
            btn.textContent = 'Added \u2713';
            /* Notify cart drawer if present */
            document.dispatchEvent(new CustomEvent('cart:added'));
            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.innerHTML = originalHTML;
              btn.disabled = false;
            }, 1200);
          }).catch(function () {
            btn.classList.remove('is-adding');
            btn.innerHTML = originalHTML; btn.disabled = false;
            form.submit(); /* let the browser submit natively */
          });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"] && !Shopify.designMode) return;
  try {
    
  function initSubscribeSection(root) {
    var form = root.querySelector('[data-subscribe-form]');
    if (!form) return;

    var emailInput = root.querySelector('[data-email-input]');
    var submitBtn = root.querySelector('[data-submit]');
    var feedback = root.querySelector('#' + form.getAttribute('aria-describedby'));
    var successBox = root.querySelector('[data-success]');
    var companyId = root.dataset.klaviyoCompany || '';
    var fallbackList = root.dataset.fallbackList || '';

    function showError(msg) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.hidden = false;
      feedback.style.color = 'var(--color-sale, #e63946)';
    }
    function clearError() {
      if (!feedback) return;
      feedback.hidden = true;
      feedback.textContent = '';
    }

    function showSuccess() {
      form.hidden = true;
      if (successBox) successBox.hidden = false;
    }

    // Build the Klaviyo subscribe URL+body for one list
    function subscribeToList(listId, email) {
      if (!listId) return Promise.resolve();
      var body = new URLSearchParams();
      body.append('g', listId);
      body.append('email', email);
      body.append('$source', window.location.hostname);
      return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
        mode: 'cors',
        credentials: 'omit'
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearError();

      var email = (emailInput.value || '').trim();
      if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
        showError('Please enter a valid email address.');
        emailInput.focus();
        return;
      }

      var checkedListIds = Array.prototype.slice
        .call(root.querySelectorAll('.subscribe__checkbox:checked'))
        .map(function (cb) { return cb.dataset.listId; })
        .filter(function (id) { return !!id; });

      // If nothing checked, fall back to the section-level default list
      if (checkedListIds.length === 0 && fallbackList) {
        checkedListIds.push(fallbackList);
      }

      if (checkedListIds.length === 0) {
        showError('Please select at least one interest.');
        return;
      }

      root.classList.add('subscribe--loading');
      submitBtn.disabled = true;

      Promise.allSettled(checkedListIds.map(function (id) { return subscribeToList(id, email); }))
        .then(function (results) {
          var anyOk = results.some(function (r) { return r.status === 'fulfilled'; });
          if (anyOk) {
            showSuccess();
          } else {
            showError(root.querySelector('[data-subscribe]') ? (form.dataset.errorMessage || 'Something went wrong. Please try again.') : 'Something went wrong.');
          }
        })
        .catch(function () {
          showError('Something went wrong. Please try again.');
        })
        .finally(function () {
          root.classList.remove('subscribe--loading');
          submitBtn.disabled = false;
        });
    });

    // Clear error on input
    emailInput.addEventListener('input', clearError);
  }

  function bootSubscribeSections() {
    document.querySelectorAll('[data-subscribe]').forEach(initSubscribeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSubscribeSections);
  } else {
    bootSubscribeSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var s = event.target.querySelector('[data-subscribe]');
    if (s) initSubscribeSection(s);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ts]').forEach(function (root) {
    var track = root.querySelector('[data-ts-track]');
    if (!track) return; /* grid layout — no carousel */

    var slides = root.querySelectorAll('[data-ts-slide]');
    var dots = root.querySelectorAll('[data-ts-dot]');
    var prev = root.querySelector('[data-ts-prev]');
    var next = root.querySelector('[data-ts-next]');
    var autoplay = parseInt(root.dataset.autoplay, 10) || 0;
    var current = 0;
    var timer = null;

    function go(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      slides.forEach(function (s, i) { s.classList.toggle('ts__slide--active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('ts__dot--active', i === idx); });
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); resetAutoplay(); });
    if (next) next.addEventListener('click', function () { go(current + 1); resetAutoplay(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); resetAutoplay(); }); });

    function startAutoplay() {
      if (autoplay <= 0 || slides.length <= 1) return;
      timer = setInterval(function () { go(current + 1); }, autoplay * 1000);
    }
    function resetAutoplay() { if (timer) { clearInterval(timer); startAutoplay(); } }

    /* Pause on hover/focus */
    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', startAutoplay);

    /* Pause when offscreen (perf) */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) startAutoplay();
          else if (timer) clearInterval(timer);
        });
      }, { threshold: 0.25 }).observe(root);
    } else {
      startAutoplay();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["user-guide-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-user-guide]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var pills = root.querySelectorAll('[data-segment-pill]');
    var panels = root.querySelectorAll('[data-segment-panel]');

    function activate(segValue, opts) {
      opts = opts || {};
      pills.forEach(function (p) {
        var isActive = p.getAttribute('data-segment-pill') === segValue;
        p.classList.toggle('user-guide__toggle-pill--active', isActive);
        p.setAttribute('aria-selected', isActive ? 'true' : 'false');
        p.setAttribute('tabindex', isActive ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-segment-panel') === segValue;
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      root.setAttribute('data-active-segment', segValue);

      if (!opts.skipUrl) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('segment', segValue);
          window.history.replaceState({}, '', url);
        } catch (e) { /* ignore */ }
      }
    }

    pills.forEach(function (pill, idx) {
      pill.addEventListener('click', function () { activate(pill.getAttribute('data-segment-pill')); });
      pill.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'Home' && e.key !== 'End') return;
        e.preventDefault();
        var nextIdx = idx;
        if (e.key === 'ArrowRight') nextIdx = (idx + 1) % pills.length;
        else if (e.key === 'ArrowLeft') nextIdx = (idx - 1 + pills.length) % pills.length;
        else if (e.key === 'Home') nextIdx = 0;
        else if (e.key === 'End') nextIdx = pills.length - 1;
        pills[nextIdx].focus();
        activate(pills[nextIdx].getAttribute('data-segment-pill'));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
